#
msgid ""
msgstr ""
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"POT-Creation-Date: 2026-02-18 11:02+0200\n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Language: fi\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"Plural-Forms: \n"
"X-Generator: @lingui/cli\n"

#. placeholder {0}: item.maxSurge
#. placeholder {0}: item.maximum
#. placeholder {0}: item.minimum
#. placeholder {1}: item.maxSurge
#. placeholder {1}: item.maximum
#. placeholder {1}: item.minimum
#: src/modules/services/FailoverNodeSelect.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "{0} {1, plural, one {node} other {nodes}}"
msgstr "{0} {1, plural, one {solmu} other {solmua}}"

#. placeholder {0}: uploadStats.uploadedFiles
#. placeholder {1}: uploadStats.totalFiles
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "{0} of {1} files uploaded"
msgstr "{0}/{1} tiedostoa lähetetty"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "{name} will be deleted permanently."
msgstr "{name} poistetaan pysyvästi."

#: src/modules/storage/StorageList.tsx
msgid "{number_of_buckets, plural, one {bucket} other {buckets}}"
msgstr "{number_of_buckets, plural, one {tallennussäiliö} other {tallennussäiliötä}}"

#. {resourceTypeName} is eg. 'virtual machine' or 'billing account'
#: src/modules/api/resourceTypeException.tsx
msgid "{resourceTypeName} with ID {id} not found"
msgstr "{resourceTypeName} tunnuksella {id} ei löytynyt"

#. ONLY:bn
#: src/styles/tenbyte/theme.tsx
msgid "<0><1>Individual/Proprietor: NID, Passport, or Driver's License.</1><2>Company/Corporate: Trade License.</2><3>Financial & Legal: Tax Identification Number (TIN), VAT Certificate.</3></0>"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "1 bare metal server"
msgstr "1 Bare metal -palvelin"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "1 day"
msgstr "1 päivä"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "1 hour"
msgstr "1 tunti"

#: src/modules/billing/omise/OmisePaymentForm.tsx
msgid "10 digit TrueMoney mobile number starting with 0"
msgstr "10-numeroinen TrueMoney-matkapuhelinnumero, joka alkaa numerolla 0"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "3 days"
msgstr "3 päivää"

#: src/modules/compute/VmView.tsx
msgid "4 weeks"
msgstr "4 viikkoa"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "6 hours"
msgstr "6 tuntia"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "7 days"
msgstr "7 päivää"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "A discount has been applied for all services under this billing account."
msgstr "Tälle laskutustilille kuuluville palveluille on myönnetty alennus."

#: src/modules/compute/VmCreate.tsx
msgid "A user account will be created with this username. It can be used to log in to the VM. Can contain ASCII letters, digits, underscores and hyphens. Must start with a letter or underscore. Maximum length is 25 characters."
msgstr "Tällä käyttäjänimellä luodaan käyttäjätili. Sitä voi käyttää virtuaalikoneeseen kirjautumiseen. Voi sisältää ASCII-kirjaimia, numeroita, alaviivoja ja yhdysmerkkejä. Sen on alettava kirjaimella tai alaviivalla. Enimmäispituus on 25 merkkiä."

#: src/modules/network/NetworkCreate.tsx
msgid "A virtual private cloud (VPC) is a private network interface for collections of your resources. VPC network is available at no additional cost."
msgstr "Virtuaalinen yksityinen pilvi (VPC) on yksityinen verkkoliitäntä resurssiesi kokonaisuuksille. VPC-verkko on saatavilla ilman lisäkustannuksia."

#: src/modules/access/AcceptInvitationModal.tsx
#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accept"
msgstr "Hyväksy"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accept invitation"
msgstr "Hyväksy kutsu"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/user/ProfileView.tsx
msgid "Accepted"
msgstr "Hyväksytty"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accepting this access invitation will grant you permission to act as \"{name}\" and perform all operations on behalf of the user."
msgstr "Hyväksymällä tämän käyttöoikeuskutsun saat oikeuden toimia käyttäjänä \"{name}\" ja suorittaa kaikki toiminnot käyttäjän puolesta."

#. Label for dropdown menu that has options related to file sharing and permissions. | POS: Noun
#. Title for section that contains credentials to connect to a database
#: src/modules/access/AccessList.tsx
#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/services/Access.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Access"
msgstr "Pääsy"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Access credentials"
msgstr "Kirjautumistiedot"

#: src/modules/api/resourceTypes.tsx
msgid "Access delegation"
msgstr "Käyttöoikeuden delegointi"

#: src/modules/user/ProfileView.tsx
msgid "Access group"
msgstr "Käyttöoikeusryhmä"

#: src/modules/user/InvitationNotice.tsx
msgid "Access has been shared with you"
msgstr "Käyttöoikeus on jaettu sinulle"

#: src/modules/api/resourceTypes.tsx
msgid "Access invitation"
msgstr "Käyttöoikeuskutsu"

#. placeholder {0}: item.access_owner
#: src/modules/user/InvitationNotice.tsx
msgid "Access invitation from {0} is pending"
msgstr "Käyttöoikeuskutsu käyttäjältä {0} odottaa hyväksyntää"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Access key ID"
msgstr "Pääsyavaimen tunnus"

#: src/modules/access/AccessCreate.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
msgid "Access name"
msgstr "Käyttöoikeuden nimi"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Access scope"
msgstr "Käyttöoikeuden laajuus"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
msgid "Access type"
msgstr "Käyttöoikeuden tyyppi"

#. Dialog title
#: src/modules/user/ActAsModal.tsx
msgid "Access user"
msgstr "Avaa käyttäjä"

#: src/modules/billing/account_validation/BillingAccountValidationBlock.tsx
#: src/modules/billing/NoValidBillingAccountNotice.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Account details are being validated."
msgstr "Tilin tietoja varmistetaan."

#: src/modules/billing/account_validation/GeneralBaValidationBlock.tsx
msgid "Account details must be validated"
msgstr "Tilin tiedot on validoitava"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Account ID"
msgstr "Tilin tunnus"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Account name"
msgstr "Tilin nimi"

#. Menu item to impersonate another user
#: src/modules/user/ActAsModal.tsx
#: src/modules/user/UserMenu.tsx
msgid "Act as"
msgstr "Esiinny käyttäjänä"

#. placeholder {0}: impersonation.access_owner
#: src/modules/user/ImpersonateTopItem.tsx
msgid "Acting as <0>{0}</0>"
msgstr "Toimit käyttäjänä <0>{0}</0>"

#. Login page title when email verification is required
#: src/modules/login/auth0/Auth0Login.tsx
msgid "Action required"
msgstr "Toimenpiteitä tarvitaan"

#. Disk status
#. Service status
#: src/modules/compute/statusLabels.tsx
#: src/modules/disks/DiskStatusBadge.tsx
msgid "Active"
msgstr "Aktiivinen"

#: src/modules/storage/StorageCreate.tsx
msgid "Actual cost of your storage is calculated hourly based on your actual usage, no upfront payments. For every started GB the price is rounded up to next whole GB."
msgstr "Tallennustilasi todellinen kustannus lasketaan tunneittain todellisen käytön perusteella, ilman ennakkomaksuja. Jokaisesta alkavasta gigatavusta hinta pyöristetään seuraavaan täyteen gigatavuun."

#: src/modules/services/ServiceView.tsx
msgid "Actual price is determined by compute and storage usage. Persistent volumes of hibernated clusters will still be charged for. See billing account current usage for more detailed information."
msgstr "Todellinen hinta määräytyy laskenta- ja tallennuskäytön perusteella. Horrostettujen klustereiden pysyvistä taltioista veloitetaan edelleen. Katso lisätietoja laskutustilin nykyisestä käytöstä."

#. Add a new row; Button action
#: src/components/EditableList.tsx
#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/compute/AddFirewallForm.tsx
#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/metal/commitment/AddCommitmentModal.tsx
#: src/modules/network/firewall/AddResourceForm.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/loadbalancer/AddForwardingRuleForm.tsx
#: src/modules/network/loadbalancer/AddTargetServerForm.tsx
#: src/modules/services/AddIpForm.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Add"
msgstr "Lisää"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Add a a payment method that supports automated top up."
msgstr "Lisää maksutapa, joka tukee automaattista saldon täydennystä."

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmView.tsx
msgid "Add additional disk"
msgstr "Lisää lisälevy"

#: src/modules/network/NetworkCreate.tsx
msgid "Add at least one forwarding rule"
msgstr "Lisää vähintään yksi välityssääntö"

#: src/modules/network/NetworkCreate.tsx
msgid "Add at least one target server"
msgstr "Lisää vähintään yksi kohdepalvelin"

#: src/modules/compute/VmCreate.tsx
msgid "Add custom configuration for the virtual machine"
msgstr "Lisää virtuaalikoneelle mukautettuja asetuksia"

#: src/modules/user/ProfileView.tsx
msgid "Add first name"
msgstr "Lisää etunimi"

#: src/modules/services/IpWhitelist.tsx
msgid "Add IP"
msgstr "Lisää IP-osoite"

#: src/modules/user/ProfileView.tsx
msgid "Add last name"
msgstr "Lisää sukunimi"

#: src/components/table/DetailsTableName.tsx
msgid "Add name"
msgstr "Lisää nimi"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Add new payment method..."
msgstr "Lisää uusi maksutapa..."

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "Add new reservation"
msgstr "Lisää uusi varaus"

#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Add new rule"
msgstr "Lisää uusi sääntö"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Add node"
msgstr "Lisää solmu"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Add node pool"
msgstr "Lisää solmupooli"

#: src/modules/billing/ActionButtons.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Add payment method"
msgstr "Lisää maksutapa"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Add payment method later"
msgstr "Lisää maksutapa myöhemmin"

#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "Add rule"
msgstr "Lisää sääntö"

#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/VmCreate.tsx
msgid "Add SSH key"
msgstr "Lisää SSH-avain"

#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "Add sub-interface"
msgstr "Lisää aliliitäntä"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Add target server"
msgstr "Lisää kohdepalvelin"

#: src/modules/access/delegation/AddImpersonationForm.tsx
msgid "Add user"
msgstr "Lisää käyttäjä"

#: src/modules/access/delegation/DelegationView.tsx
msgid "Add users"
msgstr "Lisää käyttäjiä"

#: src/modules/billing/choose_method/useAddMethod.tsx
msgid "Adding payment method failed"
msgstr "Maksutavan lisääminen epäonnistui"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/network/NetworkList.tsx
msgid "Address"
msgstr "Osoite"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Address line 2"
msgstr "Osoiterivi 2"

#. Link to administrative user interface
#: src/modules/user/UserMenu.tsx
msgid "Admin view"
msgstr "Ylläpitäjänäkymä"

#: src/components/table/DetailsTableBillingAccount.tsx
#: src/components/WTabs.tsx
msgid "All"
msgstr "Kaikki"

#. A firewall rule that applies to every source or destination IP address
#: src/modules/network/firewall/firewallLabels.tsx
msgid "All IP addresses"
msgstr "Kaikki IP-osoitteet"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "All permissions"
msgstr "Kaikki oikeudet"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "All TCP"
msgstr "Kaikki TCP"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "All UDP"
msgstr "Kaikki UDP"

#: src/modules/api/resourceTypes.tsx
msgid "Allocate a floating IP and start managing your network."
msgstr "Varaa kelluva IP-osoite ja aloita verkkosi hallinta."

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Allocated"
msgstr "Kohdistettu"

#: src/modules/network/NetworkCreate.tsx
msgid "Allocating a new IPv4 address allows you to assign it to one of your existing resources or reserve it for later use."
msgstr "Uuden IPv4-osoitteen varaaminen mahdollistaa sen liittämisen johonkin olemassa olevista resursseistasi tai varaamisen myöhempää käyttöä varten."

#: src/modules/login/Login.tsx
msgid "Already have an account?"
msgstr "Onko sinulla jo tili?"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Amount"
msgstr "Summa"

#. Field label for reservation upfront cost
#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "Amount billed upfront"
msgstr "Etukäteen veloitettava summa"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Amount is too low"
msgstr "Summa on liian pieni"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Amount should be positive"
msgstr "Summan on oltava positiivinen"

#: src/modules/billing/AutomatedTopUpModal.tsx
msgid "Amount should not be less than than minimum top up"
msgstr "Summa ei saa olla pienempi kuin vähimmäistäydennys"

#: src/modules/billing/NoValidBillingAccountNotice.tsx
msgid "An active billing account is needed to create resources."
msgstr "Resurssien luomiseen tarvitaan aktiivinen laskutustili."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "An active billing account is needed to use this feature."
msgstr "Tämän ominaisuuden käyttäminen edellyttää aktiivista laskutustiliä."

#: src/modules/billing/account_validation/BillingAccountValidationBlock.tsx
msgid "An e-mail with instructions has been sent to you."
msgstr "Sinulle on lähetetty ohjeet sisältävä sähköposti."

#: src/components/modal/WModal.tsx
#: src/components/sidebar/ListErrorBoundary.tsx
msgid "An error happened"
msgstr "Tapahtui virhe"

#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/firewall/ruleSpec.tsx
#: src/modules/network/firewall/ruleSpec.tsx
msgid "Any"
msgstr "Mikä tahansa"

#: src/modules/access/AccessList.tsx
#: src/modules/dashboard/WelcomeBlock.tsx
#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "API"
msgstr "API"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "API documentation"
msgstr "API-dokumentaatio"

#: src/modules/api/resourceTypes.tsx
msgid "API token"
msgstr "API-token"

#: src/modules/compute/labels.tsx
#: src/modules/dashboard/StartSomethingNew.tsx
msgid "App catalog"
msgstr "Sovellukset"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Appearance"
msgstr "Ulkoasu"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Apply for payment by invoice"
msgstr "Hae laskulla maksamista"

#: src/modules/compute/SubInterfaceDeleteModal.tsx
msgid "Are you sure you want to delete sub-interface with uuid {ifUuid}?"
msgstr "Haluatko varmasti poistaa aliliitännän, jonka UUID on {ifUuid}?"

#: src/modules/compute/SshKeyDeleteModal.tsx
msgid "Are you sure you want to delete the public key \"{name}\"?"
msgstr "Haluatko varmasti poistaa julkisen avaimen \"{name}\"?"

#: src/modules/main/LogoutConfirmDialog.tsx
msgid "Are you sure you want to log out?"
msgstr "Haluatko varmasti kirjautua ulos?"

#: src/modules/network/NetworkCreate.tsx
msgid "Assign to"
msgstr "Liitä kohteeseen"

#. State of IP address, attached to a resource such as a virtual machine
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkList.tsx
msgid "Assigned"
msgstr "Liitetty"

#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Assigned to"
msgstr "Liitetty kohteeseen"

#: src/modules/access/AccessCreate.tsx
msgid "At least one email is required"
msgstr "Vähintään yksi sähköpostiosoite vaaditaan"

#: src/modules/network/firewall/EditRuleModal.tsx
msgid "At least one IP is required"
msgstr "Vähintään yksi IP-osoite vaaditaan"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "At least one node pool must have autoscaler minimum value as 1 or more."
msgstr "Vähintään yhdessä solmupoolissa automaattiskaalaimen minimiarvon on oltava 1 tai enemmän."

#: src/modules/compute/VmView.tsx
msgid "Attach firewall"
msgstr "Liitä palomuuri"

#: src/modules/network/firewall/FirewallView.tsx
msgid "Attach resource"
msgstr "Liitä resurssi"

#: src/modules/disks/DiskList.tsx
msgid "Attached"
msgstr "Liitetty"

#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskCreate.tsx
msgid "Attached to"
msgstr "Liitetty kohteeseen"

#. Explanation: Switching the color schema automatically. |Alternatives: 'Automatic'
#: src/modules/main/ColorSchemeMenu.tsx
msgid "Auto"
msgstr "Automaattinen"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Auto update"
msgstr "Automaattinen päivitys"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Automated payment"
msgstr "Automaattinen maksu"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Automated top up"
msgstr "Automaattinen saldon täydennys"

#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Automatic system-level backups are enabled. Use the backup images to restore your service. Backups will be stored for 7 days, meaning you will have 7 latest backups."
msgstr "Automaattiset järjestelmätason varmuuskopiot ovat käytössä. Palauta palvelusi varmuuskopioiden levykuvien avulla. Varmuuskopioita säilytetään 7 päivää, eli käytettävissäsi on 7 uusinta varmuuskopiota."

#: src/modules/compute/VmView.tsx
msgid "Automatic system-level backups are enabled. Use the backup images to restore your virtual machine or create a new virtual machine from the backup with modified size parameters."
msgstr "Automaattiset järjestelmätason varmuuskopiot ovat käytössä. Palauta virtuaalikoneesi varmuuskopiolevykuvista tai luo varmuuskopiosta uusi virtuaalikone muutetuilla kokoparametreilla."

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Automatic updates will not update preview versions."
msgstr "Automaattiset päivitykset eivät päivitä esikatseluversioita."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Automatically top up (min. <0/>)"
msgstr "Täydennä saldo automaattisesti (väh. <0/>)"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Autoscaler max."
msgstr "Automaattiskaalaimen max."

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Autoscaler min."
msgstr "Automaattiskaalaimen min."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Available"
msgstr "Saatavilla"

#: src/modules/services/ServiceView.tsx
msgid "Awake"
msgstr "Hereillä"

#. Button action
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
msgid "Back"
msgstr "Takaisin"

#: src/modules/user/ImpersonateTopItem.tsx
#: src/modules/user/UserMenu.tsx
msgid "Back to your account"
msgstr "Takaisin omaan tiliisi"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
msgid "Backups"
msgstr "Varmuuskopiot"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Balance history"
msgstr "Saldo­historia"

#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/metal/MetalList.tsx
msgid "Bare metal"
msgstr "Bare metal"

#: src/modules/api/resourceTypes.tsx
msgid "Bare metal server"
msgstr "Bare metal -palvelin"

#: src/modules/billing/BaseCurrencyField.tsx
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Base currency"
msgstr "Perusvaluutta"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Begin your billing account validation process."
msgstr "Aloita laskutustilin validointiprosessi."

#: src/modules/compute/SubInterfaceModal.tsx
msgid "Below is an example of how to configure this sub-interface on a Linux server."
msgstr "Alla on esimerkki siitä, miten tämä aliliitäntä määritetään Linux-palvelimella."

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Billed"
msgstr "Laskutettu"

#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Billing"
msgstr "Laskutus"

#: src/components/table/DetailsTableBillingAccount.tsx
#: src/components/table/DetailsTableBillingAccount.tsx
#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/forms/BillingAccountField.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Billing account"
msgstr "Laskutustili"

#. Price list annotation
#: src/modules/pricing/PricingModal.tsx
msgid "Billing account \"{title}\" has discount {discount_percentage}%"
msgstr "Laskutustilillä \"{title}\" on {discount_percentage} %:n alennus"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Billing account is limited"
msgstr "Laskutustili on rajoitettu"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Billing account name"
msgstr "Laskutustilin nimi"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Billing account override"
msgstr "Laskutustilin ohitus"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Billing account suspended"
msgstr "Laskutustili keskeytetty"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Billing account validation was rejected"
msgstr "Laskutustilin vahvistus hylättiin"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Billing accounts"
msgstr "Laskutustilit"

#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "Billing cycle"
msgstr "Laskutusjakso"

#: src/modules/disks/disk/DiskView.tsx
msgid "Boot"
msgstr "Käynnistys"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Boot from ISO medium"
msgstr "Käynnistä ISO-medialta"

#. Virtual machine choice: UEFI or BIOS
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
msgid "Boot mode"
msgstr "Käynnistystila"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Booting is only possible when the virtual machine is stopped."
msgstr "Käynnistys on mahdollista vain, kun virtuaalikone on pysäytetty."

#. {payment method} provided by {payment gateway name}
#: src/modules/billing/utils.tsx
msgid "by {gatewayName}"
msgstr "{gatewayName}"

#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "By continuing with the top up you agree to the <0>Terms & Conditions</0>, <1>Privacy Policy</1> & <2>Refund Policy</2>."
msgstr "Jatkamalla saldon täydennystä hyväksyt <0>käyttöehdot</0>, <1>tietosuojakäytännön</1> ja <2>palautuskäytännön</2>."

#: src/modules/compute/VmView.tsx
msgid "By disabling backups there will not be any further automatic backups made from your virtual machine. Backups done by this point will be kept as is and you can still use them. You can enable backups again whenever needed."
msgstr "Kun poistat varmuuskopiot käytöstä, virtuaalikoneestasi ei enää luoda uusia automaattisia varmuuskopioita. Tähän mennessä luodut varmuuskopiot säilytetään sellaisenaan ja voit edelleen käyttää niitä. Voit ottaa varmuuskopiot uudelleen käyttöön milloin tahansa."

#: src/modules/access/AccessCreate.tsx
msgid "By selecting “Global”, all resources under this user account can be accessed. Exercise caution when selecting “Global” scope."
msgstr "Valitsemalla ”Globaali” voidaan käyttää kaikkia tämän käyttäjätilin resursseja. Ole varovainen valitessasi ”Globaali”-laajuuden."

#: src/modules/access/AccessCreate.tsx
msgid "By selecting “Restricted”, access will be limited to resources belonging to the selected billing account."
msgstr "Valitsemalla ”Rajoitettu” käyttöoikeus rajoitetaan valittuun laskutustiliin kuuluviin resursseihin."

#: src/modules/login/auth0/Auth0Login.tsx
msgid "By signing up, you agree to the <0>Terms of Service</0>"
msgstr "Rekisteröitymällä hyväksyt <0>käyttöehdot</0>"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Campaign code"
msgstr "Kampanjakoodi"

#: src/modules/dashboard/UserAccess.tsx
msgid "Can access me"
msgstr "Muille jaetut käyttöoikeudet"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Cancel"
msgstr "Peruuta"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Cancel uploads"
msgstr "Peruuta lataukset"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Cancelled"
msgstr "Peruutettu"

#: src/modules/billing/payment_forms/labels.tsx
msgid "Card number"
msgstr "Kortin numero"

#: src/modules/billing/omise/parseOmisePersistentData.ts
msgid "Card verification failed"
msgstr "Kortin vahvistus epäonnistui"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "Change"
msgstr "Vaihda"

#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/ChangePasswordModal.tsx
msgid "Change password"
msgstr "Vaihda salasana"

#: src/modules/login/Login.tsx
msgid "Change your password by clicking the verification link we just sent to your inbox."
msgstr "Vaihda salasanasi klikkaamalla vahvistuslinkkiä, jonka lähetimme juuri sähköpostiisi."

#: src/modules/user/ProfileView.tsx
msgid "Changing the password failed"
msgstr "Salasanan vaihtaminen epäonnistui"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "Changing the password is only possible when the virtual machine is running."
msgstr "Salasanan vaihtaminen on mahdollista vain, kun virtuaalikone on käynnissä."

#: src/modules/billing/forms/BillingAccountField.tsx
msgid "Choose a billing account for your new resource to consolidate your resources under a suitable payment method."
msgstr "Valitse uudelle resurssillesi laskutustili, jotta voit yhdistää resurssisi sopivan maksutavan alle."

#: src/modules/access/AccessCreate.tsx
msgid "Choose a billing account you wish to share access to"
msgstr "Valitse laskutustili, johon haluat jakaa käyttöoikeuden"

#: src/modules/network/NetworkCreate.tsx
msgid "Choose a resource to assign the IP to or leave it unassigned. You can always assign the IP to a suitable resource later"
msgstr "Valitse resurssi, johon IP-osoite liitetään, tai jätä se liittämättä. Voit aina liittää IP-osoitteen sopivaan resurssiin myöhemmin."

#: src/modules/disks/DiskCreate.tsx
msgid "Choose a virtual machine to attach the disk to, or leave it detached and connect it to a virtual machine later."
msgstr "Valitse virtuaalikone, johon levy liitetään, tai jätä se irti ja liitä se virtuaalikoneeseen myöhemmin."

#: src/modules/compute/VmCreate.tsx
#: src/modules/services/ServiceCreate.tsx
msgid "Choose a VPC network for your resource from already existing one or create a new private network."
msgstr "Valitse resurssillesi VPC-verkko jo olemassa olevista tai luo uusi yksityinen verkko."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Choose billing account"
msgstr "Valitse laskutustili"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/choose_method/ChooseMethod.tsx
msgid "Choose method"
msgstr "Valitse menetelmä"

#: src/modules/network/NetworkCreate.tsx
msgid "Choose the VPC network the target servers are in."
msgstr "Valitse VPC-verkko, jossa kohdepalvelimet ovat."

#: src/modules/compute/VmCreate.tsx
msgid "Choose UEFI if the VM you are importing requires it."
msgstr "Valitse UEFI, jos tuomasi virtuaalikone edellyttää sitä."

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "City"
msgstr "Kaupunki"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Cleaning"
msgstr "Puhdistus"

#: src/modules/notifications/NotificationMenu.tsx
msgid "Clear all"
msgstr "Tyhjennä kaikki"

#. Button: Remove the over-ride of the billing account for this bucket
#: src/modules/storage/bucket/BucketView.tsx
msgid "Clear override"
msgstr "Poista ohitus"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Clear uploads"
msgstr "Tyhjennä lataukset"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Click the button to connect to PayPal."
msgstr "Yhdistä PayPaliin napsauttamalla painiketta."

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/compute/VmCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
msgid "Clone"
msgstr "Kloonaa"

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
msgid "Clone resource"
msgstr "Kloonaa resurssi"

#. Button action
#: src/components/modal/WModal.tsx
#: src/components/sidebar/ErrorItem.tsx
#: src/modules/access/delegation/AddImpersonationForm.tsx
#: src/modules/compute/AddFirewallForm.tsx
#: src/modules/network/firewall/AddResourceForm.tsx
#: src/modules/network/loadbalancer/AddForwardingRuleForm.tsx
#: src/modules/network/loadbalancer/AddTargetServerForm.tsx
#: src/modules/services/AddIpForm.tsx
msgid "Close"
msgstr "Sulje"

#. Label for an authentication error code
#: src/modules/login/auth0/Auth0Login.tsx
msgid "Code:"
msgstr "Koodi:"

#. Server has been pre-paid
#: src/modules/metal/commitment/CommitmentPriceBlock.tsx
msgid "Committed"
msgstr "Maksettu etukäteen"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Company name"
msgstr "Yrityksen nimi"

#: src/styles/dataxion/theme.tsx
msgid "Company RNE number"
msgstr "Yrityksen RNE-numero"

#: src/modules/access/token/TokenView.tsx
msgid "Comprehensive API manual with code samples is available here:"
msgstr "Kattava API-opas koodiesimerkeillä on saatavilla täällä:"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Compute"
msgstr "Laskenta"

#. Alternative: Configure a custom subnet range
#: src/modules/network/NetworkCreate.tsx
msgid "Configure my own"
msgstr "Määritä itse"

#: src/modules/login/Login.tsx
msgid "Confirm email"
msgstr "Vahvista sähköposti"

#: src/modules/compute/PasswordFields.tsx
msgid "Confirm password"
msgstr "Vahvista salasana"

#: src/modules/login/Login.tsx
msgid "Confirm your email address by clicking the verification link we just sent to your inbox."
msgstr "Vahvista sähköpostiosoitteesi klikkaamalla vahvistuslinkkiä, jonka lähetimme juuri sähköpostiisi."

#: src/components/modal/DeleteModal.tsx
#: src/modules/main/LogoutConfirmDialog.tsx
msgid "Confirmation"
msgstr "Vahvistus"

#: src/modules/compute/WVnc.tsx
msgid "Connect"
msgstr "Yhdistä"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Connect to PayPal first"
msgstr "Yhdistä ensin PayPaliin"

#: src/modules/compute/WVnc.tsx
msgid "Connecting"
msgstr "Yhdistetään"

#: src/modules/billing/progressLabels.tsx
msgid "Connecting payment method"
msgstr "Yhdistetään maksutapa"

#. Title for section that contains credentials to connect to a database
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/services/ServiceView.tsx
msgid "Connection details"
msgstr "Yhteystiedot"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Contact person's name"
msgstr "Yhteyshenkilön nimi"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Contact person's phone"
msgstr "Yhteyshenkilön puhelin"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/support/ContactSupportButton.tsx
msgid "Contact support"
msgstr "Ota yhteyttä tukeen"

#: src/modules/billing/account_validation/digio/StartDigioValidationButton.tsx
#: src/modules/login/ConsentForm.tsx
#: src/modules/login/Login.tsx
msgid "Continue"
msgstr "Jatka"

#: src/components/ClipBoardTooltip.tsx
msgid "Copied!"
msgstr "Kopioitu!"

#. Full form: Copy to clipboard
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Copy"
msgstr "Kopioi"

#: src/modules/services/Access.tsx
msgid "Copy config to clipboard"
msgstr "Kopioi määritys leikepöydälle"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Copy public URL"
msgstr "Kopioi julkinen URL-osoite"

#: src/components/ClipBoardTooltip.tsx
msgid "Copy to clipboard"
msgstr "Kopioi leikepöydälle"

#. All the main resources and services offered by the cloud platform
#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Core services"
msgstr "Ydinpalvelut"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Country"
msgstr "Maa"

#. Part of address
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "County"
msgstr "Piirikunta"

#: src/modules/compute/MetricsGrid.tsx
#: src/modules/compute/VmSizeSelect.tsx
#: src/modules/compute/VmSizeSelect.tsx
msgid "CPU"
msgstr "CPU"

#. Button: Create a new resource
#: src/components/forms/CreateFormAction.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Create"
msgstr "Luo"

#. Button: Create new billing account
#: src/modules/dashboard/BillingAccounts.tsx
msgctxt "Should be short (1-3 words)"
msgid "Create"
msgstr "Luo"

#: src/modules/billing/BillingList.tsx
msgid "Create a billing account first, then you can start creating resources."
msgstr "Luo ensin laskutustili, jonka jälkeen voit aloittaa resurssien luomisen."

#: src/modules/api/resourceTypes.tsx
msgid "Create a dedicated bare metal server and run your application with maximum performance."
msgstr "Luo dedikoitu bare metal -palvelin ja suorita sovelluksesi maksimaalisella suorituskyvyllä."

#: src/modules/error/ErrorFallback.tsx
msgid "Create a new {resourceTypeName}"
msgstr "Luo uusi {resourceTypeName}"

#: src/modules/access/AccessList.tsx
msgid "Create a new access to enable other users or systems to perform actions with this {siteName} account."
msgstr "Luo uusi käyttöoikeus, jotta muut käyttäjät tai järjestelmät voivat suorittaa toimintoja tällä {siteName}-tilillä."

#: src/modules/disks/DiskList.tsx
msgid "Create a new disk and start storing your data."
msgstr "Luo uusi levy ja aloita tietojesi tallentaminen."

#: src/modules/compute/VmList.tsx
#: src/modules/metal/MetalList.tsx
msgid "Create a new resource and get your services running in minutes."
msgstr "Luo uusi resurssi ja saat palvelusi käyntiin minuuteissa."

#: src/modules/network/NetworkList.tsx
msgid "Create a new resource and start managing your network."
msgstr "Luo uusi resurssi ja aloita verkkosi hallinta."

#: src/modules/services/ServicesList.tsx
msgid "Create a new service and get it running in minutes."
msgstr "Luo uusi palvelu ja ota se käyttöön minuuteissa."

#: src/modules/api/resourceTypes.tsx
msgid "Create a new storage account, create some buckets and start storing your data in a scalable way - Pay-as-you-grow."
msgstr "Luo uusi tallennustili, luo tallennussäiliöitä ja aloita datasi tallentaminen skaalautuvasti – maksat käytön mukaan."

#: src/modules/storage/StorageList.tsx
msgid "Create a new storage account, create some buckets and start storing your data."
msgstr "Luo uusi tallennustili, luo tallennussäiliöitä ja aloita datasi tallentaminen."

#: src/modules/api/resourceTypes.tsx
msgid "Create a new Virtual Machine or choose something from the App Catalog to get your services running in minutes."
msgstr "Luo uusi virtuaalikone tai valitse sovellus sovelluskatalogista, jotta saat palvelusi käyntiin muutamassa minuutissa."

#: src/modules/api/resourceTypes.tsx
msgid "Create a personal Virtual Private Cloud (VPC) and start managing your networks."
msgstr "Luo oma Virtual Private Cloud (VPC) ja aloita verkkojesi hallinta."

#: src/modules/network/CreateAndAssignIpField.tsx
msgid "Create a public IPv4 address for the resource"
msgstr "Luo resurssille julkinen IPv4-osoite"

#: src/modules/disks/DiskCreate.tsx
msgid "Create additional storage for your workloads. Configure the disk and attach it to a virtual machine now or later."
msgstr "Luo lisätallennustilaa työkuormillesi. Määritä levy ja liitä se virtuaalikoneeseen nyt tai myöhemmin."

#: src/modules/login/Login.tsx
msgid "Create an account"
msgstr "Luo tili"

#: src/modules/api/resourceTypes.tsx
msgid "Create an API Token to use our API."
msgstr "Luo API-token käyttääksesi rajapintaamme."

#. placeholder {0}: getResourceTypeName(type)
#: src/components/loading/Loading.tsx
msgid "Create another {0}"
msgstr "Luo toinen {0}"

#: src/components/forms/CreateBillingAccount.tsx
msgid "Create billing account"
msgstr "Luo laskutustili"

#: src/components/forms/CreateBillingAccount.tsx
#: src/modules/access/AccessCreate.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/dashboard/AppCatalog.tsx
#: src/modules/dashboard/CoreServices.tsx
#: src/modules/dashboard/ManagedServices.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/account/CreateBucketModal.tsx
#: src/modules/storage/account/CreateBucketModal.tsx
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/StorageCreate.tsx
#: src/modules/storage/StorageList.tsx
msgid "Create new"
msgstr "Luo uusi"

#. Created at timestamp
#: src/modules/access/AccessList.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/user/ProfileView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Created"
msgstr "Luotu"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Created at"
msgstr "Luotu"

#: src/modules/access/AccessList.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/services/ServicesList.tsx
msgid "Created date"
msgstr "Luontipäivä"

#: src/modules/compute/ModalHeaderBlock.tsx
msgid "Created from"
msgstr "Luotu lähteestä"

#. Virtual machine status
#: src/components/loading/Loading.tsx
#: src/modules/compute/statusLabels.tsx
msgid "Creating"
msgstr "Luodaan"

#: src/modules/access/AccessCreate.tsx
msgid "Creating an access by API Token gives you a key to use with our API."
msgstr "API-tokenilla luotu käyttöoikeus antaa sinulle avaimen, jolla voit käyttää API:a."

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Credit"
msgstr "Hyvitys"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Credit Note {id}"
msgstr "Hyvityslasku {id}"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Current"
msgstr "Nykyinen"

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "Current billing cycle"
msgstr "Nykyinen laskutusjakso"

#. Explanation: Restoring a snapshot or backup will delete the current state of the virtual machine.
#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Current changes will be discarded."
msgstr "Nykyiset muutokset hylätään."

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Current usage"
msgstr "Nykyinen käyttö"

#: src/modules/compute/VmSizeSelect.tsx
msgid "Currently not available"
msgstr "Ei tällä hetkellä saatavilla"

#. Custom operating system
#: src/modules/compute/os/OsInfo.tsx
#: src/modules/network/firewall/ruleSpec.tsx
msgid "Custom"
msgstr "Mukautettu"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Custom ISO image"
msgstr "Mukautettu ISO-levykuva"

#: src/modules/support/WChatProvider.tsx
msgid "Customer support"
msgstr "Asiakastuki"

#: src/modules/billing/payment_forms/labels.tsx
msgid "CVC"
msgstr "CVC"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Dark"
msgstr "Tumma"

#: src/modules/dashboard/Dashboard.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Dashboard"
msgstr "Kojelauta"

#: src/modules/location/LocationDetail.tsx
msgid "Data center where resource is located"
msgstr "Datakeskus, jossa resurssi sijaitsee"

#: src/modules/location/LocationField.tsx
msgid "Data center where the resource will be created."
msgstr "Datakeskus, johon resurssi luodaan."

#: src/components/forms/WSelect.tsx
msgid "Data missing"
msgstr "Tietoja puuttuu"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Date"
msgstr "Päivämäärä"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Declined / Suspended"
msgstr "Hylätty / keskeytetty"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/dashboard/BillingAccounts.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Default"
msgstr "Oletus"

#: src/modules/access/AccessCreate.tsx
msgid "Delegate access to"
msgstr "Delegoi käyttöoikeus käyttäjälle"

#: src/modules/api/resourceTypes.tsx
msgid "Delegate access to your user or billing account so trusted users can manage your resources."
msgstr "Delegoi käyttöoikeus käyttäjätiliisi tai laskutustiliisi, jotta luotetut käyttäjät voivat hallita resurssejasi."

#: src/modules/user/ProfileView.tsx
msgid "Delegate new access"
msgstr "Delegoi uusi käyttöoikeus"

#: src/modules/access/AccessCreate.tsx
msgid "Delegating access to a chosen trusted user enables the user to act as you and perform all operations on behalf of your user or billing account."
msgstr "Käyttöoikeuden delegointi valitulle luotetulle käyttäjälle antaa käyttäjälle mahdollisuuden toimia puolestasi ja suorittaa kaikki toiminnot käyttäjäsi tai laskutustilisi puolesta."

#: src/components/button/DeleteButton.tsx
#: src/components/modal/DeleteModal.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Delete"
msgstr "Poista"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "Delete floating IP"
msgstr "Poista kelluva IP-osoite"

#. Virtual machine status
#: src/modules/compute/statusLabels.tsx
#: src/modules/metal/status/StatusLabels.tsx
msgid "Deleted"
msgstr "Poistettu"

#: src/modules/metal/MetalDeleteModal.tsx
msgid "Deleting \"{display_name}\" will permanently remove it, and it will not be accessible after that."
msgstr "Poistaminen \"{display_name}\" poistaa sen pysyvästi, eikä se ole sen jälkeen käytettävissä."

#: src/modules/metal/MetalDeleteModal.tsx
msgid "Deleting \"{display_name}\" would destroy a resource that has already been paid for. Please contact support for assistance."
msgstr "Kohteen \"{display_name}\" poistaminen tuhoaisi jo maksetun resurssin. Ota yhteyttä tukeen saadaksesi apua."

#: src/modules/access/delegation/DelegationView.tsx
msgid "Deleting \"{name}\" will permanently remove access from all the users in this group to act as you."
msgstr "Poistamalla \"{name}\" poistat pysyvästi tämän ryhmän kaikilta käyttäjiltä oikeuden toimia puolestasi."

#. Items: means files or folders
#. placeholder {0}: files.length
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Deleting {count} {0, plural, one {item} other {items}}."
msgstr "Poistetaan {count} {0, plural, one {kohde} other {kohdetta}}."

#: src/modules/compute/VmDeleteReplicaModal.tsx
msgid "Deleting a backup will permanently remove it."
msgstr "Varmuuskopion poistaminen poistaa sen pysyvästi."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting a billing account \"{title}\" will remove it permanently. Billing account can be deleted only if there are no unpaid resources attached to it and if it has no unspent credit."
msgstr "Laskutustilin \"{title}\" poistaminen poistaa sen pysyvästi. Laskutustilin voi poistaa vain, jos siihen ei ole liitetty maksamattomia resursseja ja jos sillä ei ole käyttämätöntä saldoa."

#. placeholder {0}: method.name
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting a payment method \"{0}\" will remove it from the billing account."
msgstr "Maksutavan \"{0}\" poistaminen poistaa sen laskutustililtä."

#: src/modules/services/ServiceDeleteModal.tsx
msgid "Deleting a service will also delete your backups and the service cannot be restored after that."
msgstr "Palvelun poistaminen poistaa myös varmuuskopiosi, eikä palvelua voi sen jälkeen palauttaa."

#: src/modules/compute/VmDeleteReplicaModal.tsx
msgid "Deleting a snapshot will permanently remove it."
msgstr "Tilannekuvan poistaminen poistaa sen pysyvästi."

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Deleting the access key \"{accessKey}\" will permanently remove it, and it cannot be used for accessing the storage API after that."
msgstr "Pääsyavaimen \"{accessKey}\" poistaminen poistaa sen pysyvästi, eikä sitä voi sen jälkeen käyttää tallennus-API:n käyttöön."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting the credit card \"{placeholder}\" will permanently remove it from the billing account."
msgstr "Luottokortin \"{placeholder}\" poistaminen poistaa sen pysyvästi laskutustililtä."

#: src/modules/compute/DiskDeleteModal.tsx
msgid "Deleting the disk will permanently remove it, and it will not be accessible after that."
msgstr "Levyn poistaminen poistaa sen pysyvästi, eikä se ole enää käytettävissä sen jälkeen."

#. placeholder {0}: name || address
#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "Deleting the floating IP address \"{0}\" will remove it from your account and release it to the public pool."
msgstr "Kelluvan IP-osoitteen \"{0}\" poistaminen poistaa sen tililtäsi ja vapauttaa sen julkiseen osoitepooliin."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting the invoice method will permanently remove it from the billing account."
msgstr "Laskumenetelmän poistaminen poistaa sen pysyvästi laskutustililtä."

#: src/modules/services/ServiceDeleteModal.tsx
msgid "Deleting the service \"{display_name}\" will permanently remove it, and it will not be accessible after that."
msgstr "Palvelun \"{display_name}\" poistaminen poistaa sen pysyvästi, eikä se ole sen jälkeen käytettävissä."

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Deleting the storage account \"{title}\" will permanently remove it and delete all associated keys. Accounts with active buckets cannot be deleted."
msgstr "Tallennustilin \"{title}\" poistaminen poistaa sen pysyvästi sekä kaikki siihen liittyvät avaimet. Tilejä, joilla on aktiivisia tallennussäiliöitä, ei voi poistaa."

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Deleting the storage bucket \"{name}\" will permanently remove it, and any files in it will not be accessible after that."
msgstr "Tallennussäiliön \"{name}\" poistaminen poistaa sen pysyvästi, eikä siinä oleviin tiedostoihin pääse sen jälkeen enää käsiksi."

#: src/modules/access/token/TokenView.tsx
msgid "Deleting the token \"{description}\" will permanently remove it, and it cannot be used for authentication after that."
msgstr "Poistamalla tokenin \"{description}\" poistat sen pysyvästi, eikä sitä voi sen jälkeen käyttää tunnistautumiseen."

#: src/modules/compute/VmDeleteModal.tsx
msgid "Deleting the virtual machine \"{name}\" will permanently remove it, and it will not be accessible after that."
msgstr "Virtuaalikoneen \"{name}\" poistaminen poistaa sen pysyvästi, eikä se ole sen jälkeen käytettävissä."

#: src/modules/compute/VmDeleteModal.tsx
msgid "Deleting the virtual machine will also delete your backups and snapshots, and the machine cannot be restored after that. If you wish to keep the backups and snapshots consider stopping the machine instead."
msgstr "Virtuaalikoneen poistaminen poistaa myös varmuuskopiot ja tilannekuvat, eikä konetta voi sen jälkeen palauttaa. Jos haluat säilyttää varmuuskopiot ja tilannekuvat, harkitse koneen pysäyttämistä poistamisen sijaan."

#: src/modules/network/vpc/VpcView.tsx
msgid "Deleting the VPC network \"{name}\" will remove it from your account."
msgstr "VPC-verkon \"{name}\" poistaminen poistaa sen tililtäsi."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Description"
msgstr "Kuvaus"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Destinations"
msgstr "Kohteet"

#: src/modules/disks/AttachedToSelect.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/disks/UnattachedItem.tsx
msgid "Detached"
msgstr "Irrotettu"

#: src/modules/compute/VmView.tsx
msgid "Disable"
msgstr "Poista käytöstä"

#: src/modules/compute/VmView.tsx
msgid "Disable backups"
msgstr "Poista varmuuskopiot käytöstä"

#: src/modules/user/ProfileView.tsx
msgid "Disable MFA"
msgstr "Poista MFA käytöstä"

#: src/components/EnabledDisabled.tsx
msgid "Disabled"
msgstr "Ei käytössä"

#: src/modules/compute/WVnc.tsx
msgid "Disconnect"
msgstr "Katkaise yhteys"

#. State of connection: Not connected
#: src/modules/compute/WVnc.tsx
msgid "Disconnected"
msgstr "Ei yhdistetty"

#. Column title for invoice records' discount
#: src/components/PriceWithDiscount.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Discount"
msgstr "Alennus"

#: src/modules/api/resourceTypes.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Disk"
msgstr "Levy"

#: src/modules/compute/MetricsGrid.tsx
msgid "Disk I/O"
msgstr "Levyn I/O"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
msgid "Disk size can only be increased. This action is not reversible. Minimum disk size:"
msgstr "Levyn kokoa voi vain kasvattaa. Tätä toimintoa ei voi perua. Levyn vähimmäiskoko:"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Disks"
msgstr "Levyt"

#: src/modules/billing/CurrencyPaymentFees.tsx
#: src/modules/currency/CurrencyModal.tsx
#: src/modules/currency/CurrencyModal.tsx
msgid "Display currency"
msgstr "Näytettävä valuutta"

#: src/modules/storage/StorageCreate.tsx
msgid "Display name"
msgstr "Näyttönimi"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Document"
msgstr "Asiakirja"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Document file"
msgstr "Asiakirjatiedosto"

#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Document No."
msgstr "Asiakirjan numero"

#. Button action to download a file. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Download"
msgstr "Lataa"

#: src/modules/services/Access.tsx
msgid "Download config file"
msgstr "Lataa määritystiedosto"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Download PDF"
msgstr "Lataa PDF"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Drop files here"
msgstr "Pudota tiedostot tähän"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Due date"
msgstr "Eräpäivä"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "E-mail"
msgstr "Sähköposti"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/UpdateSshKeyModal.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Edit"
msgstr "Muokkaa"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Edit \"{title}\""
msgstr "Muokkaa \"{title}\""

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Edit maintenance"
msgstr "Muokkaa huoltoa"

#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Edit name"
msgstr "Muokkaa nimeä"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Edit node"
msgstr "Muokkaa solmua"

#: src/modules/network/firewall/EditRuleModal.tsx
msgid "Edit rule"
msgstr "Muokkaa sääntöä"

#. Field label
#: src/components/EditableList.tsx
#: src/modules/login/Login.tsx
#: src/modules/user/ProfileView.tsx
msgid "Email"
msgstr "Sähköposti"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Email domain is prohibited"
msgstr "Sähköpostiosoitteen verkkotunnus ei ole sallittu"

#: src/modules/login/Login.tsx
msgid "Email verification failed"
msgstr "Sähköpostin vahvistus epäonnistui"

#: src/modules/login/Login.tsx
msgid "Email verified"
msgstr "Sähköposti vahvistettu"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Email where invoices and reports are sent."
msgstr "Sähköposti, johon laskut ja raportit lähetetään."

#: src/modules/compute/VmCreate.tsx
msgid "Empty disk (for ISO booting)"
msgstr "Tyhjä levy (ISO-käynnistystä varten)"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Enable"
msgstr "Ota käyttöön"

#: src/modules/user/ProfileView.tsx
msgid "Enable MFA"
msgstr "Ota MFA käyttöön"

#: src/modules/access/AccessCreate.tsx
msgid "Enable other users or systems to perform actions with resources connected to this account."
msgstr "Salli muiden käyttäjien tai järjestelmien suorittaa toimintoja tähän tiliin liitetyillä resursseilla."

#: src/components/EnabledDisabled.tsx
msgid "Enabled"
msgstr "Käytössä"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "End date"
msgstr "Päättymispäivä"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "End port"
msgstr "Loppuportti"

#: src/modules/network/firewall/validatePorts.ts
msgid "End port must be greater than start port"
msgstr "Loppuportin on oltava suurempi kuin alkuportti"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Ended"
msgstr "Päättynyt"

#: src/modules/compute/AddSubInterfaceModal.tsx
msgid "Enter a value between 1 and 4094"
msgstr "Anna arvo väliltä 1–4094"

#. Card security code validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Enter digits only"
msgstr "Syötä vain numeroita"

#. placeholder {0}: currency.title
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Enter the top up amount in {0} (minimum {minimumAmount}):"
msgstr "Syötä täydennettävä summa (vähintään {minimumAmount}):"

#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/error/Isolated.tsx
#: src/modules/login/Login.tsx
#: src/modules/notifications/toast.tsx
msgid "Error"
msgstr "Virhe"

#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Error adding payment method"
msgstr "Virhe maksutavan lisäämisessä"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Error code: {code}"
msgstr "Virhekoodi: {code}"

#: src/components/button/WButton.tsx
msgid "Error performing action"
msgstr "Virhe toimintoa suoritettaessa"

#: src/modules/notifications/toast.tsx
msgid "Error saving changes"
msgstr "Muutosten tallentaminen epäonnistui"

#: src/modules/compute/VmView.tsx
msgid "Est. cost per backup"
msgstr "Arvioitu kustannus varmuuskopiota kohden"

#: src/components/table/DetailsTableMonthlyCost.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Est. monthly cost"
msgstr "Arvioitu kuukausikustannus"

#. Short of: Estimated
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Est. total"
msgstr "Arvioitu yhteensä"

#: src/components/forms/MonthlyCostField.tsx
msgid "Estimated cost"
msgstr "Arvioitu kustannus"

#: src/modules/pricing/ReplicaPrice.tsx
msgid "Estimated price per backup is {priceWithDiscount} per month."
msgstr "Arvioitu hinta per varmuuskopio on {priceWithDiscount} kuukaudessa."

#: src/modules/pricing/ReplicaPrice.tsx
msgid "Estimated price per snapshot is {priceWithDiscount} per month."
msgstr "Arvioitu hinta per tilannekuva on {priceWithDiscount} kuukaudessa."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Every new user receives a {c_totalReceiverCredit} worth of free credits when signing up through the referral link or code and adding a verified payment method."
msgstr "Jokainen uusi käyttäjä saa {c_totalReceiverCredit} arvosta maksutonta saldoa, kun hän rekisteröityy suosittelulinkin tai -koodin kautta ja lisää vahvistetun maksutavan."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Every new user who signs up through the referral program and tops up at least {c_minimumTopUp} will receive a bonus worth of {c_totalReceiverCredit} credits."
msgstr "Jokainen uusi käyttäjä, joka rekisteröityy suositteluohjelman kautta ja täydentää saldoa vähintään {c_minimumTopUp}, saa {c_totalReceiverCredit} arvoisen saldobonuksen."

#: src/modules/compute/SubInterfaceModal.tsx
msgid "Example"
msgstr "Esimerkki"

#: src/modules/currency/CurrencyModal.tsx
#: src/modules/currency/DisplayCurrencyRate.tsx
msgid "Exchange rate"
msgstr "Valuuttakurssi"

#. Short of: Excluding (VAT/GST etc.)
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Excl. {vatSymbol}"
msgstr "Ilman {vatSymbol}"

#. The number of fail-over nodes:
#: src/modules/services/ServiceCreate.tsx
msgid "Fail-over nodes"
msgstr "Vikasietosolmut"

#: src/modules/api/ApiError.ts
msgid "Failed to connect to server"
msgstr "Palvelimeen ei saatu yhteyttä"

#: src/modules/billing/account_validation/digio/utils.ts
msgid "Failed to load Digio library"
msgstr "Digio-kirjaston lataaminen epäonnistui"

#: src/modules/billing/paypal/utils.ts
msgid "Failed to load PayPal library"
msgstr "PayPal-kirjaston lataaminen epäonnistui"

#: src/modules/billing/popup/popup.ts
msgid "Failed to open popup, possible popup blocker usage"
msgstr "Ponnahdusikkunan avaaminen epäonnistui, mahdollinen ponnahdusikkunoiden esto käytössä"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "File"
msgstr "Tiedosto"

#: src/modules/storage/bucket/BucketView.tsx
msgid "Files"
msgstr "Tiedostot"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Files will be uploaded to"
msgstr "Tiedostot ladataan kohteeseen"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "Firewall"
msgstr "Palomuuri"

#: src/modules/network/NetworkCreate.tsx
msgid "Firewall is available at no additional cost."
msgstr "Palomuuri on saatavilla ilman lisäkustannuksia."

#: src/modules/compute/VmView.tsx
msgid "Firewall name"
msgstr "Palomuurin nimi"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Firewall now available"
msgstr "Palomuuri on nyt saatavilla"

#: src/modules/user/ProfileView.tsx
msgid "First name"
msgstr "Etunimi"

#: src/modules/services/ConnectionDetails.tsx
msgid "Flags"
msgstr "Liput"

#: src/modules/api/resourceTypes.tsx
msgid "Floating IP"
msgstr "Kelluva IP-osoite"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Folder"
msgstr "Kansio"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Folder name"
msgstr "Kansion nimi"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "For every new user who signs up through the referral program and tops up at least {c_minimumTopUp}, you will receive {c_promoterCredit} worth of free credits."
msgstr "Jokaisesta uudesta käyttäjästä, joka rekisteröityy suositteluohjelman kautta ja täydentää saldoa vähintään {c_minimumTopUp}, saat {c_promoterCredit} arvosta maksutonta saldoa."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "For every new user who signs up using your referral code and adds a verified payment method, you will receive {c_promoterCredit} worth of free credits."
msgstr "Jokaisesta uudesta käyttäjästä, joka rekisteröityy suosittelukoodillasi ja lisää vahvistetun maksutavan, saat {c_promoterCredit} arvosta maksutonta saldoa."

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "For pay-as-you-go billing account you can select the payment method after the account is created and validated."
msgstr "Maksu käytön mukaan -laskutustilille voit valita maksutavan sen jälkeen, kun tili on luotu ja validoitu."

#: src/modules/compute/labels.tsx
msgid "For the snapshots you will only pay for the storage used by the snapshot."
msgstr "Tilannekuvista maksat vain tilannekuvan käyttämästä tallennustilasta."

#. Unsafely shut down the virtual machine
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
msgid "Force stop"
msgstr "Pakota pysäytys"

#: src/modules/login/Login.tsx
#: src/modules/login/Login.tsx
msgid "Forgot password"
msgstr "Unohditko salasanasi"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Forwarding rules"
msgstr "Välityssäännöt"

#. At no cost. | POS: Noun
#: src/components/forms/MonthlyCostField.tsx
msgid "Free"
msgstr "Maksuton"

#: src/modules/compute/VmView.tsx
#: src/modules/services/Backups.tsx
msgid "Frequency"
msgstr "Tiheys"

#: src/modules/services/ServicesList.tsx
msgid "from"
msgstr "alkaen"

#: src/modules/compute/VmCreate.tsx
msgid "From"
msgstr "Lähde"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Full path"
msgstr "Koko polku"

#: src/modules/services/ServiceView.tsx
msgid "Fully managed database so you can focus on your code."
msgstr "Täysin hallinnoitu tietokanta, jotta voit keskittyä koodiisi."

#: src/modules/api/resourceTypes.tsx
msgid "Fully managed services - we handle the provisioning of underlying infrastructure and the management of the service."
msgstr "Täysin hallinnoidut palvelut – huolehdimme taustalla olevan infrastruktuurin käyttöönotosta ja palvelun hallinnasta."

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Future"
msgstr "Tuleva"

#. Payment gateway that the card is connected to
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Gateway"
msgstr "Maksuyhdyskäytävä"

#. unit: gigabytes
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/l10n/units.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "GB"
msgstr "GB"

#. Example: 50 GB (of) disk
#: src/modules/l10n/units.tsx
msgid "GB disk"
msgstr "GB levyä"

#. Example: 16 GB (of) RAM
#: src/modules/compute/VmSizeSelect.tsx
#: src/modules/l10n/units.tsx
msgid "GB RAM"
msgstr "GB RAM"

#. unit: gigabyte-hours (storage usage)
#: src/modules/l10n/units.tsx
msgid "GBh"
msgstr "GBh"

#. Explanation: Generate the subnet range automatically
#: src/modules/network/NetworkCreate.tsx
msgid "Generate (recommended)"
msgstr "Luo automaattisesti (suositeltu)"

#: src/modules/access/AccessCreate.tsx
msgid "Generate an API access token to use our <0>API</0>."
msgstr "Luo API-käyttötoken, jotta voit käyttää <0>API</0>:a."

#: src/modules/access/scopeLabel.tsx
msgid "Global"
msgstr "Globaali"

#: src/modules/error/ErrorFallback.tsx
msgid "Go to dashboard"
msgstr "Siirry hallintapaneeliin"

#. Sales tax acronym in India
#: src/styles/hostzop/theme.tsx
msgid "GST"
msgstr "GST"

#. Sales tax acronym in India
#: src/styles/hostzop/theme.tsx
msgid "GST number"
msgstr "GST-numero"

#. unit: hours
#: src/modules/l10n/units.tsx
msgid "h"
msgstr "h"

#. Chat widget greeting
#: src/modules/support/WChatProvider.tsx
msgid "Hello"
msgstr "Hei"

#: src/routes/_main_custom/about.lazy.tsx
msgid "Hello world!"
msgstr "Hei maailma!"

#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Hibernate"
msgstr "Horrostila"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Hibernated"
msgstr "Horrostettu"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Hibernating"
msgstr "Horrostetaan"

#. Button action
#: src/components/SecretKey.tsx
#: src/modules/services/TextSecret.tsx
msgid "Hide"
msgstr "Piilota"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Hide details"
msgstr "Piilota tiedot"

#: src/modules/api/resourceTypes.tsx
msgid "High availability load balancer distributes traffic between virtual machines within the same data center location."
msgstr "Korkean käytettävyyden kuormantasaaja jakaa liikenteen virtuaalikoneiden kesken samassa palvelinkeskussijainnissa."

#. Time period unit
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/metal/offer/period.tsx
msgid "hour"
msgstr "tunti"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Hourly"
msgstr "Tuntiperusteinen"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Hourly billing cycle only"
msgstr "Vain tuntiperusteinen laskutusjakso"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Hourly updated usage for current billing period."
msgstr "Nykyisen laskutuskauden käyttö päivitetään tunnin välein."

#: src/modules/dashboard/UserAccess.tsx
msgid "I can access"
msgstr "Minulle jaetut käyttöoikeudet"

#: src/modules/login/ConsentForm.tsx
msgid "I have read and agree to the <0>Terms of Service</0>"
msgstr "Olen lukenut ja hyväksyn <0>käyttöehdot</0>"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "I'm aware that deletion is permanent"
msgstr "Ymmärrän, että poistaminen on pysyvää"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "If low balance notifications are active and the balance falls below the threshold, you will be notified."
msgstr "Jos alhaisen saldon ilmoitukset ovat käytössä ja saldo alittaa raja-arvon, saat ilmoituksen."

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "If the active reservation runs out and is not renewed then standard hourly based pricing will be applied."
msgstr "Jos aktiivinen varaus päättyy eikä sitä uusita, käytetään normaalia tuntiperusteista hinnoittelua."

#: src/modules/billing/choose_method/InvoiceForm.tsx
msgid "If the invoice payment method is not activated instantly, we will contact you with more details. If you do not receive an email from us soon or the invoice payment does not become active, you can contact us at <0/>."
msgstr "Jos laskumaksutapa ei aktivoidu heti, otamme sinuun yhteyttä lisätietojen kanssa. Jos et saa meiltä pian sähköpostia tai laskumaksu ei aktivoidu, voit ottaa meihin yhteyttä osoitteessa <0/>."

#: src/modules/dashboard/Dashboard.tsx
msgid "If you have any questions, found a bug or have a feature request feel free to contact us through <0>support</0>."
msgstr "Jos sinulla on kysyttävää, löysit virheen tai haluat ehdottaa uutta ominaisuutta, ota meihin yhteyttä <0>tuen</0> kautta."

#. Description for billing period field
#: src/modules/metal/offer/period.tsx
msgid "In all calculations a precise number of hours is used: 730 for a month, 2190 for a quarter and 8760 for a year."
msgstr "Kaikissa laskelmissa käytetään tarkkaa tuntimäärää: kuukaudessa 730, neljännesvuodessa 2190 ja vuodessa 8760 tuntia."

#: src/modules/metal/status/StatusLabels.tsx
msgid "In use"
msgstr "Käytössä"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Inactive"
msgstr "Ei aktiivinen"

#. Short of: inbound firewall rules
#: src/modules/network/NetworkList.tsx
msgid "inbound"
msgstr "sisään"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Inbound rules"
msgstr "Saapuvat säännöt"

#. The price has already been included in the virtual machine's price
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Included in VM price"
msgstr "Sisältyy virtuaalikoneen hintaan"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Incoming traffic is allowed only to the specified ports if it originates from the specified sources. All other traffic will be blocked."
msgstr "Saapuva liikenne sallitaan vain määritettyihin portteihin, jos se on peräisin määritetyistä lähteistä. Kaikki muu liikenne estetään."

#: src/modules/compute/VmCreate.tsx
msgid "Informative name. It will also be used to generate a suitable hostname for the VM (if applicable)."
msgstr "Kuvaava nimi. Sitä käytetään myös sopivan konenimen luomiseen virtuaalikoneelle (jos sovellettavissa)."

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/ServiceView.tsx
msgid "Infrastructure"
msgstr "Infrastruktuuri"

#: src/modules/compute/VmCreate.tsx
msgid "Initialization script"
msgstr "Alustusskripti"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Insert code"
msgstr "Syötä koodi"

#: src/modules/access/AccessCreate.tsx
msgid "Insert email of the {siteName} user you want to delegate access to. The user will need to accept the access invitation from their profile view."
msgstr "Syötä sen {siteName}-käyttäjän sähköpostiosoite, jolle haluat delegoida käyttöoikeuden. Käyttäjän on hyväksyttävä käyttöoikeuskutsu profiilinäkymästä."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Insufficient funds"
msgstr "Riittämätön saldo"

#. Field label: identifier used to connect a billing account to an external integration
#. Unique ID number to integrate with external services
#: src/modules/billing/billingAccount/fieldsInfo.tsx
#: src/styles/defaultTheme.tsx
msgid "Integration ID"
msgstr "Integraatiotunnus"

#. Card expiration validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Invalid month"
msgstr "Virheellinen kuukausi"

#: src/modules/api/ApiError.ts
msgid "Invalid response from server. Blocked by Stormwall."
msgstr "Virheellinen vastaus palvelimelta. Stormwall esti pyynnön."

#: src/modules/api/ApiError.ts
msgid "Invalid response type from server: Received {ct} instead of JSON."
msgstr "Virheellinen vastaustyyppi palvelimelta: vastaanotettiin {ct} JSONin sijaan."

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Invalid signup. The account may already exist."
msgstr "Rekisteröityminen epäonnistui. Tili voi olla jo olemassa."

#. Card expiration validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Invalid year"
msgstr "Virheellinen vuosi"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Invoice"
msgstr "Lasku"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Invoice {id}"
msgstr "Lasku {id}"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Invoice details"
msgstr "Laskutustiedot"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Invoice email"
msgstr "Laskutussähköposti"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Invoice has been paid"
msgstr "Lasku on maksettu"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Invoice is not payable"
msgstr "Laskua ei voi maksaa"

#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Invoice name"
msgstr "Laskun nimi"

#: src/components/themeTrans.tsx
msgid "Invoices"
msgstr "Laskut"

#: src/modules/services/IpWhitelist.tsx
msgid "IP"
msgstr "IP"

#: src/modules/services/AddIpForm.tsx
msgid "IP address"
msgstr "IP-osoite"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "IP address or CIDR range"
msgstr "IP-osoite tai CIDR-alue"

#. A list of IPs permitted to access the service | Legacy wording: IP whitelist
#: src/modules/services/IpWhitelist.tsx
#: src/modules/services/ServiceView.tsx
msgid "IP allowlist"
msgstr "Sallittujen IP-osoitteiden luettelo"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "IP prefixes"
msgstr "IP-etuliitteet"

#: src/modules/network/NetworkCreate.tsx
msgid "IP range"
msgstr "IP-alue"

#: src/modules/network/vpc/VpcView.tsx
msgid "IPv4 range"
msgstr "IPv4-alue"

#: src/modules/network/vpc/VpcView.tsx
msgid "IPv6 range"
msgstr "IPv6-alue"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "ISO boot"
msgstr "ISO-käynnistys"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Issue date"
msgstr "Laatimispäivä"

#. Date the invoice was issued
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Issued"
msgstr "Myönnetty"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "Keep floating IP"
msgstr "Säilytä kelluva IP-osoite"

#: src/modules/user/ActAsModal.tsx
msgid "Keep in mind that all the actions will be tracked and can be traced back to you."
msgstr "Huomioi, että kaikkia toimintoja seurataan ja ne voidaan jäljittää sinuun."

#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Key name"
msgstr "Avaimen nimi"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Kubernetes Patch Version"
msgstr "Kubernetesin paikkausversio"

#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Kubernetes Patch Version Auto update"
msgstr "Kubernetesin paikkausversion automaattinen päivitys"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Kubernetes service can not be created."
msgstr "Kubernetes-palvelua ei voi luoda."

#: src/modules/l10n/LocaleButton.tsx
msgid "Language"
msgstr "Kieli"

#: src/modules/network/vpc/VpcView.tsx
msgid "Last modified"
msgstr "Viimeksi muokattu"

#: src/modules/user/ProfileView.tsx
msgid "Last name"
msgstr "Sukunimi"

#: src/modules/compute/VmView.tsx
msgid "Latest backup"
msgstr "Uusin varmuuskopio"

#. Timestamp of latest snapshot
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/services/Backups.tsx
msgid "Latest snapshot"
msgstr "Uusin tilannekuva"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Less details"
msgstr "Vähemmän tietoja"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Light"
msgstr "Vaalea"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Limit will be removed once the total top up amount reaches <0/>."
msgstr "Rajoitus poistetaan, kun kokonaistäydennyssumma saavuttaa <0/>."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Limited"
msgstr "Rajoitettu"

#. Column title for invoice records' totals - record amount subtracted by discount
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Line total"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Linked resources"
msgstr "Liitetyt resurssit"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "list price"
msgstr "listahinta"

#: src/modules/api/resourceTypes.tsx
msgid "Load balancer"
msgstr "Kuormantasaaja"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Load more"
msgstr "Lataa lisää"

#: src/modules/billing/progressLabels.tsx
msgid "Loading payment provider"
msgstr "Ladataan maksupalveluntarjoajaa"

#: src/components/forms/WSelect.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Loading..."
msgstr "Ladataan..."

#: src/modules/compute/VmList.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/location/LocationDetail.tsx
#: src/modules/location/LocationField.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/pricing/PricingModal.tsx
#: src/modules/services/ServicesList.tsx
msgid "Location"
msgstr "Sijainti"

#: src/modules/login/ApiKeyLogin.tsx
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
#: src/modules/login/Login.tsx
#: src/modules/login/LoginLayout.tsx
msgid "Log in"
msgstr "Kirjaudu sisään"

#: src/modules/login/Login.tsx
msgid "Log in with Google"
msgstr "Kirjaudu sisään Googlella"

#: src/modules/main/LogoutConfirmDialog.tsx
#: src/modules/user/LogoutButton.tsx
#: src/modules/user/UserMenu.tsx
msgid "Log out"
msgstr "Kirjaudu ulos"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "Logging in"
msgstr "Kirjaudu sisään"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "Login error"
msgstr "Kirjautumisvirhe"

#: src/modules/dashboard/WelcomeModal.tsx
msgid "Look around first"
msgstr "Tutustu ensin"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Low balance notification is not in effect because automated top up is activated."
msgstr "Alhaisen saldon ilmoitus ei ole käytössä, koska automaattinen saldon täydennys on aktivoitu."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Low balance notifications"
msgstr "Ilmoitukset alhaisesta saldosta"

#. MAC address
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "MAC"
msgstr "MAC"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Machine details"
msgstr "Koneen tiedot"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is available for immediate leasing by clients."
msgstr "Kone on saatavilla asiakkaiden välittömään vuokraukseen."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is being used by client and is being charged."
msgstr "Kone on asiakkaan käytössä ja siitä veloitetaan."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is ordered by client, but does not satisfy the required configuration.<0/>After it has been configured as needed, move to “in use” status."
msgstr "Asiakas on tilannut koneen, mutta se ei täytä vaadittua kokoonpanoa.<0/>Kun se on määritetty tarpeen mukaan, siirrä tila \"käytössä\"."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is unavailable or requires repairs."
msgstr "Kone ei ole käytettävissä tai se vaatii korjausta."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine requires disk cleaning operations."
msgstr "Kone vaatii levyn puhdistustoimenpiteitä."

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Machine type"
msgstr "Konetyyppi"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/ServiceView.tsx
msgid "Maintenance"
msgstr "Ylläpito"

#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/UserMenu.tsx
msgid "Manage"
msgstr "Hallitse"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Manage API keys"
msgstr "Hallitse API-avaimia"

#: src/modules/api/resourceTypes.tsx
msgid "Managed service"
msgstr "Hallinnoitu palvelu"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Managed services"
msgstr "Hallinnoidut palvelut"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Max. surge"
msgstr "Enimmäislisäys"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Maximize"
msgstr "Suurenna"

#: src/modules/billing/forms/FileWithSourceInput.tsx
msgid "Maximum upload file size is {maxFileSizeInMB} MB"
msgstr "Ladattavan tiedoston enimmäiskoko on {maxFileSizeInMB} Mt"

#. unit: megabytes
#: src/modules/l10n/units.tsx
msgid "MB"
msgstr "MB"

#. unit: megabytes per second
#: src/modules/l10n/units.tsx
msgid "MB/s"
msgstr "MB/s"

#. unit: megabits per second
#: src/modules/l10n/units.tsx
msgid "Mbit/s"
msgstr "Mbit/s"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Method"
msgstr "Tapa"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Methods available after validation"
msgstr "Validoimisen jälkeen käytettävissä olevat menetelmät"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/services/Metrics.tsx
#: src/modules/services/ServiceView.tsx
msgid "Metrics"
msgstr "Mittarit"

#: src/modules/compute/monitor/MetricChart.tsx
msgid "Metrics for this resource are not loaded for performance reasons"
msgstr "Tämän resurssin metriikoita ei ladattu suorituskykysyistä"

#: src/modules/user/ProfileView.tsx
msgid "MFA is active for your user."
msgstr "MFA on käytössä käyttäjällesi."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Minimize"
msgstr "Pienennä"

#. The selected item was not found
#: src/components/forms/WSelect.tsx
msgid "Missing"
msgstr "Puuttuu"

#. If the disk is a boot disk
#: src/modules/compute/VmView.tsx
msgid "Mode"
msgstr "Tila"

#. Time period unit
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/metal/offer/MetalOfferSection.tsx
#: src/modules/metal/offer/period.tsx
msgid "month"
msgstr "kk"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Monthly"
msgstr "Kuukausittainen"

#: src/components/sidebar/PriceBlock.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/StorageList.tsx
msgid "Monthly cost"
msgstr "Kuukausikustannus"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "More details"
msgstr "Lisää tietoja"

#: src/modules/user/ProfileView.tsx
msgid "Multi-factor authentication (MFA)"
msgstr "Monivaiheinen tunnistautuminen (MFA)"

#: src/modules/billing/forms/BillingSelect.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "N/A"
msgstr "Ei käytettävissä"

#: src/components/table/DetailsTableName.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/UpdateSshKeyModal.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageList.tsx
#: src/modules/user/ProfileView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Name"
msgstr "Nimi"

#: src/modules/billing/payment_forms/components.tsx
msgid "Name (Min {minChars} chars)"
msgstr "Nimi (vähintään {minChars} merkkiä)"

#: src/modules/billing/payment_forms/components.tsx
msgid "Name is too short"
msgstr "Nimi on liian lyhyt"

#: src/modules/support/WChatProvider.tsx
msgid "Need help?"
msgstr "Tarvitsetko apua?"

#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/network/NetworkList.tsx
msgid "Network"
msgstr "Verkko"

#: src/modules/compute/MetricsGrid.tsx
msgid "Network bandwidth"
msgstr "Verkon kaistanleveys"

#: src/modules/compute/VmView.tsx
msgid "Network interfaces"
msgstr "Verkkoliitännät"

#: src/modules/compute/VmView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Networking"
msgstr "Verkko"

#: src/components/sidebar/SidebarList.tsx
#: src/modules/network/NetworkList.tsx
msgid "New"
msgstr "Uusi"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New file name"
msgstr "Uuden tiedoston nimi"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New folder"
msgstr "Uusi kansio"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New folder name"
msgstr "Uuden kansion nimi"

#: src/modules/network/VpcNetworkSelect.tsx
msgid "New network"
msgstr "Uusi verkko"

#: src/modules/compute/PasswordFields.tsx
msgid "New password"
msgstr "Uusi salasana"

#: src/modules/compute/AddSshKeyModal.tsx
msgid "New SSH key"
msgstr "Uusi SSH-avain"

#: src/styles/nforce/theme.tsx
msgid "NForce customer ID"
msgstr "NForce-asiakastunnus"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "No active card"
msgstr "Ei aktiivista korttia"

#. Chart empty state: no metric samples are available
#: src/modules/compute/monitor/MetricChart.tsx
msgid "No data"
msgstr "Ei tietoja"

#. Fail-over is disabled, no fail-over nodes
#: src/modules/services/FailoverNodeSelect.tsx
msgid "No Fail-over"
msgstr "No Fail-over"

#: src/modules/dashboard/UserAccess.tsx
msgid "No one can access your user account yet"
msgstr "Kenelläkään ei ole vielä pääsyä käyttäjätiliisi"

#: src/modules/dashboard/UserAccess.tsx
msgid "No one has shared access with you yet"
msgstr "Kukaan ei ole vielä jakanut sinulle käyttöoikeutta"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "No payment will be made currently. You can change your payment method at any time."
msgstr "Maksua ei suoriteta tällä hetkellä. Voit vaihtaa maksutapaa milloin tahansa."

#: src/components/empty.tsx
msgid "No records"
msgstr "Ei tietueita"

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "No reservation billing cycles are available for this server."
msgstr "Tälle palvelimelle ei ole saatavilla varauksen laskutusjaksoja."

#: src/components/sidebar/EmptyItem.tsx
#: src/modules/dashboard/AppCatalog.tsx
#: src/modules/dashboard/ManagedServices.tsx
msgid "No results found"
msgstr "Ei hakutuloksia"

#. Short of: Number of storage buckets
#: src/modules/storage/account/StorageAccountView.tsx
msgid "No. of buckets"
msgstr "Tallennussäiliöiden määrä"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "No. of files"
msgstr "Tiedostojen määrä"

#. Short of: Number of resources
#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/NetworkList.tsx
msgid "No. of resources"
msgstr "Resurssien määrä"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "No. of rules"
msgstr "Sääntöjen määrä"

#: src/modules/services/Backups.tsx
#: src/modules/services/Metrics.tsx
msgid "Node"
msgstr "Solmu"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Node pool"
msgstr "Solmupooli"

#: src/modules/services/ServiceCreate.tsx
msgid "Node pools"
msgstr "Solmupoolit"

#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "nodes"
msgstr "solmut"

#. Items: means files or folders
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Note: If you are deleting substantial number of items, the deletion process may result in an inconsistent state, where some items are deleted while others remain. In the event of such occurrences, please repeat the same action again."
msgstr "Huomaa: Jos poistat suuren määrän kohteita, poistoprosessi voi johtaa epäjohdonmukaiseen tilaan, jossa osa kohteista poistuu ja osa jää jäljelle. Jos näin käy, toista sama toiminto uudelleen."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Note: If your folder contains a substantial number of files, the renaming process will take time and may result in an inconsistent state where some files are moved to a new location, while others remain in the old folder. In the event of such occurrences, please repeat the action by renaming the same folder once more."
msgstr "Huomaa: Jos kansiosi sisältää huomattavan määrän tiedostoja, uudelleennimeäminen kestää aikaa ja voi johtaa epäjohdonmukaiseen tilaan, jossa osa tiedostoista siirtyy uuteen sijaintiin ja osa jää vanhaan kansioon. Jos näin käy, toista toiminto nimeämällä sama kansio uudelleen vielä kerran."

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Note! The owner will know if you have accepted this invitation. They will not be able to access your user account and see or edit any of your resources."
msgstr "Huom! Omistaja näkee, jos hyväksyt tämän kutsun. Hän ei kuitenkaan voi käyttää käyttäjätiliäsi eikä nähdä tai muokata resurssejasi."

#: src/modules/notifications/NotificationMenu.tsx
msgid "Notifications"
msgstr "Ilmoitukset"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Notify when balance goes below"
msgstr "Ilmoita, kun saldo alittaa"

#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Notify when balance goes below the following threshold. Keep in mind that the actual limit is defined in base currency."
msgstr "Ilmoita, kun saldo laskee alle seuraavan raja-arvon. Huomioi, että todellinen raja määritetään perusvaluutassa."

#. Availability announcement for AMD EPYC cloud resources
#: src/styles/readyidc/theme.tsx
msgid "Now available"
msgstr "Nyt saatavilla"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Offline"
msgstr "Poissa käytöstä"

#. Backup frequency
#: src/modules/services/Backups.tsx
msgid "Once a day"
msgstr "Kerran päivässä"

#: src/modules/compute/VmView.tsx
msgid "Once a week (Wednesday at 02:00 UTC)"
msgstr "Kerran viikossa (keskiviikkoisin klo 02.00 UTC)"

#: src/modules/storage/account/SuspendedNotice.tsx
msgid "One of your billing accounts has a problem and your buckets have been suspended. See <0>billing account details</0> for more information or contact support to resolve the issue."
msgstr "Yhdessä laskutileistäsi on ongelma ja tallennussäiliösi on keskeytetty. Katso lisätietoja <0>laskutilin tiedoista</0> tai ota yhteyttä tukeen ongelman ratkaisemiseksi."

#: src/modules/billing/BillingList.tsx
#: src/modules/billing/ReportStatus.tsx
msgid "Ongoing"
msgstr "Käynnissä"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Ongoing balance"
msgstr "Nykyinen saldo"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
msgid "Online"
msgstr "Verkossa"

#. Only payment methods that can be charged automatically
#: src/modules/billing/choose_method/ChooseMethod.tsx
msgid "Only automated methods"
msgstr "Vain automaattiset maksutavat"

#: src/modules/compute/VmCreate.tsx
msgid "Only the boot disk will be created! This may cause the OS to not boot properly if the configuration in the OS of source snapshot requires additional disks to be present."
msgstr "Vain käynnistyslevy luodaan! Tämä saattaa aiheuttaa sen, ettei käyttöjärjestelmä käynnisty oikein, jos lähdetilannekuvan käyttöjärjestelmän määritykset edellyttävät lisälevyjen olevan olemassa."

#: src/modules/compute/labels.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Operating system"
msgstr "Käyttis"

#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Operating system Auto update"
msgstr "Käyttöjärjestelmän automaattinen päivitys"

#: src/modules/login/Login.tsx
msgid "Or"
msgstr "Tai"

#: src/styles/dataxion/theme.tsx
msgid "Order"
msgstr "Tilaus"

#: src/styles/dataxion/theme.tsx
msgid "Orders"
msgstr "Tilaukset"

#. Short of: Operating system
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "OS"
msgstr "KJ"

#. Short of: outbound firewall rules
#: src/modules/network/NetworkList.tsx
msgid "outbound"
msgstr "ulos"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Outbound rules"
msgstr "Lähtevät säännöt"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Outgoing traffic is allowed only to the specified ports of the specified destinations. All other traffic will be blocked."
msgstr "Lähtevä liikenne sallitaan vain määritettyjen kohteiden määritettyihin portteihin. Kaikki muu liikenne estetään."

#: src/modules/billing/BillingList.tsx
msgid "Outstanding amount"
msgstr "Avoin saldo"

#: src/modules/billing/ReportStatus.tsx
msgid "Paid"
msgstr "Maksettu"

#: src/modules/services/ConnectionDetails.tsx
msgid "Parameters"
msgstr "Parametrit"

#: src/modules/compute/PasswordFields.tsx
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/user/ProfileView.tsx
msgid "Password"
msgstr "Salasana"

#: src/modules/compute/PasswordFields.tsx
msgid "Password for the user. Must contain at least one lowercase and one uppercase ASCII letter (a-z, A-Z) and at least one digit (0-9). Minimum length is 8 characters."
msgstr "Käyttäjän salasana. Sen on sisällettävä vähintään yksi pieni ja yksi iso ASCII-kirjain (a–z, A–Z) sekä vähintään yksi numero (0–9). Vähimmäispituus on 8 merkkiä."

#: src/modules/compute/PasswordFields.tsx
msgid "Passwords do not match"
msgstr "Salasanat eivät täsmää"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Past"
msgstr "Mennyt"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Path style URL"
msgstr "Polkumuotoinen URL-osoite"

#. Button action: pay for unpaid invoice
#: src/modules/billing/ActionButtons.tsx
msgid "Pay"
msgstr "Maksa"

#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Pay invoice"
msgstr "Maksa lasku"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Pay now"
msgstr "Maksa nyt"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Pay-as-you-go (recommended)"
msgstr "Maksu käytön mukaan (suositeltu)"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/paymentMethodLogic.tsx
msgid "Paying by invoice"
msgstr "Maksetaan laskulla"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Paying by invoice (declined / suspended)"
msgstr "Maksetaan laskulla (hylätty / keskeytetty)"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Paying by invoice (pending)"
msgstr "Maksetaan laskulla (odottaa käsittelyä)"

#: src/modules/billing/PaymentReturn.tsx
msgid "Payment authorization check finished."
msgstr "Maksun valtuutuksen tarkistus on valmis."

#: src/modules/billing/sslcommerz/parseSslcommerzPersistentData.ts
msgid "Payment cancelled"
msgstr "Maksu peruttiin"

#: src/modules/billing/sslcommerz/parseSslcommerzPersistentData.ts
msgid "Payment cancelled due to high risk"
msgstr "Maksu peruttiin korkean riskin vuoksi"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Payment details"
msgstr "Maksutiedot"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment error"
msgstr "Maksuvirhe"

#: src/modules/billing/payment/paymentUtils.ts
msgid "Payment error: {failure_message}{codeSuffix}"
msgstr "Maksuvirhe: {failure_message}{codeSuffix}"

#: src/modules/billing/clictopay/parseClictopayPaymentResult.ts
#: src/modules/billing/coingate/parseCoingatePaymentResult.ts
#: src/modules/billing/paypal/parsePaypalCheckoutPaymentResult.tsx
#: src/modules/billing/razorpay/parseRazorpayPersistentData.ts
msgid "Payment failed"
msgstr "Maksu epäonnistui"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment method"
msgstr "Maksutapa"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Payment methods"
msgstr "Maksutavat"

#: src/modules/billing/payment_forms/components.tsx
msgid "Payment processing with this method takes some time. Purchased credit will be automatically added to your account once the process is complete."
msgstr "Maksun käsittely tällä menetelmällä kestää jonkin aikaa. Ostettu saldo lisätään tilillesi automaattisesti, kun käsittely on valmis."

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Payment type"
msgstr "Maksutyyppi"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment was cancelled"
msgstr "Maksu peruutettiin"

#. unit: pieces
#: src/modules/l10n/units.tsx
msgid "pc"
msgstr "kpl"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/metal/status/StatusLabels.tsx
#: src/modules/user/ProfileView.tsx
msgid "Pending"
msgstr "Odottaa"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Period"
msgstr "Jakso"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Permissions"
msgstr "Oikeudet"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Personal ID number"
msgstr "Henkilötunnus"

#: src/modules/billing/omise/OmisePaymentForm.tsx
#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "Phone number"
msgstr "Puhelinnumero"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Platform provided"
msgstr "Alustan tarjoamat"

#: src/modules/billing/choose_method/invoiceMethodLogic.tsx
msgid "Please acknowledge that billing account will not be activated before an administrator has accepted your request."
msgstr "Vahvista, että laskutustiliä ei aktivoida ennen kuin ylläpitäjä on hyväksynyt pyyntösi."

#: src/modules/billing/choose_method/useAddMethod.tsx
msgid "Please allow popup windows to use this payment method"
msgstr "Salli ponnahdusikkunat tämän maksutavan käyttämiseksi"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Please be patient"
msgstr "Ole hyvä ja odota"

#: src/modules/billing/progressLabels.tsx
msgid "Please complete the payment in the popup window"
msgstr "Viimeistele maksu ponnahdusikkunassa"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Please contact support to remove the limit."
msgstr "Ota yhteyttä tukeen rajoituksen poistamiseksi."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Please contact the administrators for further details."
msgstr "Ota yhteyttä ylläpitäjiin saadaksesi lisätietoja."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Please continue."
msgstr "Jatka."

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "Please enter a valid name"
msgstr "Anna kelvollinen nimi"

#: src/modules/login/Login.tsx
msgid "Please enter your email address. We will send you an email to reset your password."
msgstr "Syötä sähköpostiosoitteesi. Lähetämme sinulle sähköpostin salasanan vaihtamista varten."

#: src/modules/access/AccessCreate.tsx
msgid "Please finish adding the email"
msgstr "Viimeistele sähköpostiosoitteen lisääminen"

#: src/modules/storage/bucket/bucketMessages.tsx
msgid "Please note that the billing account linked to your storage bucket differs from the one associated with your storage account. We highly recommend aligning them for billing consistency and clearer management."
msgstr "Huomaa, että tallennussäiliöösi liitetty laskutustili eroaa tallennustiliisi liitetystä laskutustilistä. Suosittelemme vahvasti käyttämään samaa laskutustiliä laskutuksen yhdenmukaisuuden ja selkeämmän hallinnan vuoksi."

#: src/components/forms/MonthlyCostField.tsx
msgid "Please see how the cost of your resource is calculated."
msgstr "Katso, miten resurssisi kustannus lasketaan."

#: src/modules/network/loadbalancer/TargetServersList.tsx
msgid "Please select a VPC network to choose target servers from."
msgstr "Valitse VPC-verkko, josta kohdepalvelimet valitaan."

#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
msgid "Please select an item in the list"
msgstr "Valitse kohde luettelosta"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Please upload a copy of the business registration document or ID card for verification (max {maxFileSizeInMB}MB)."
msgstr "Lataa vahvistusta varten kopio kaupparekisteriotteesta tai henkilökortista (enintään {maxFileSizeInMB} Mt)."

#: src/modules/services/ServiceView.tsx
msgid "Pods and services hosted on this cluster will be stopped and any ephemeral storage will be discarded."
msgstr "Tässä klusterissa ajetut podit ja palvelut pysäytetään, ja kaikki väliaikainen tallennustila hävitetään."

#: src/modules/billing/popup/popup.ts
msgid "Popup did not return from redirect"
msgstr "Ponnahdusikkuna ei palannut uudelleenohjauksesta"

#: src/modules/billing/popup/popup.ts
msgid "Popup was closed before it could load"
msgstr "Ponnahdusikkuna suljettiin ennen kuin se ehti latautua"

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Port"
msgstr "Portti"

#: src/modules/network/validatePort.ts
msgid "Port must be between 1 and 65535"
msgstr "Portin numeron on oltava välillä 1–65535"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Port range"
msgstr "Porttialue"

#: src/modules/services/ServiceCreate.tsx
msgid "PostgreSQL multi-node setup is a Primary/Standby setup with automatic fail-over."
msgstr "PostgreSQL:n monisolmukokoonpano on ensisijainen/varalla -kokoonpano, jossa on automaattinen vikasieto."

#. Resources attached to the billing account that have already been paid for
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Pre-paid resources"
msgstr "Etukäteen maksetut resurssit"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Pre-payment"
msgstr "Ennakkomaksu"

#: src/modules/compute/VmList.tsx
msgid "Price"
msgstr "Hinta"

#: src/modules/compute/VmCreate.tsx
#: src/modules/pricing/PricingModal.tsx
msgid "Price list"
msgstr "Hinnasto"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Price per cycle"
msgstr "Hinta laskutusjaksoa kohden"

#: src/modules/pricing/PricingModal.tsx
msgid "Price per hour"
msgstr "Hinta per tunti"

#: src/modules/pricing/PricingModal.tsx
msgid "Price per month"
msgstr "Hinta per kuukausi"

#: src/modules/pricing/PricingModal.tsx
msgid "Prices may vary for the options below"
msgstr "Alla olevien vaihtoehtojen hinnat voivat vaihdella"

#. The card that is selected for automatic charging (ie. main)
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
msgid "Primary"
msgstr "Ensisijainen"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Private"
msgstr "Yksityinen"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Private images"
msgstr "Yksityiset levykuvat"

#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
msgid "Private IP"
msgstr "Yksityinen IP-osoite"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Networking.tsx
#: src/modules/services/ServiceView.tsx
msgid "Private IPv4"
msgstr "Yksityinen IPv4"

#: src/modules/services/Networking.tsx
msgid "Private network"
msgstr "Yksityinen verkko"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Problem with PayPal API."
msgstr "PayPalin rajapinnassa on ongelma."

#: src/modules/user/ProfileView.tsx
#: src/modules/user/UserMenu.tsx
msgid "Profile"
msgstr "Profiili"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Protocol"
msgstr "Protokolla"

#: src/modules/compute/VmCreate.tsx
msgid "Provide a valid cloud-config as JSON or YAML. This configuration will be passed as cloud-init user-data to the virtual machine. See cloud-init documentation about cloud-config for all the available options."
msgstr "Anna kelvollinen cloud-config JSON- tai YAML-muodossa. Tämä määritys välitetään virtuaalikoneelle cloud-init user-data -tietona. Katso cloud-initin cloud-config-dokumentaatiosta kaikki käytettävissä olevat vaihtoehdot."

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Provider start of maintenance time window in which Provider may schedule automated cluster updates."
msgstr "Palveluntarjoajan huoltoikkunan alkuaika, jonka aikana palveluntarjoaja voi ajoittaa automaattisia klusteripäivityksiä."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Public"
msgstr "Julkinen"

#: src/components/table/DetailsTableIpAddress.tsx
msgid "Public IP addresses are managed in the Network view."
msgstr "Julkisia IP-osoitteita hallitaan Verkko-näkymässä."

#: src/components/table/DetailsTableIpAddress.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Public IPv4"
msgstr "Julkinen IPv4"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Public IPv6"
msgstr "Julkinen IPv6"

#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/user/ProfileView.tsx
msgid "Public key"
msgstr "Julkinen avain"

#: src/modules/compute/labels.tsx
msgid "Public key part of the SSH key pair for logging in to the VM. Must be in format <0>ssh-key-type base64encoded...key optional_comment</0>."
msgstr "Julkinen avain, joka on osa virtuaalikoneeseen kirjautumiseen käytettävää SSH-avainparia. Sen on oltava muodossa <0>ssh-key-type base64encoded...key optional_comment</0>."

#: src/modules/services/ConnectionDetails.tsx
msgid "Public network"
msgstr "Julkinen verkko"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Public URL"
msgstr "Julkinen URL-osoite"

#. Short of: Quantity
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Qty."
msgstr "Määrä"

#. Time period unit
#: src/modules/metal/offer/period.tsx
msgid "quarter"
msgstr "neljännesvuosi"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Quarterly"
msgstr "Neljännesvuosittainen"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
#: src/modules/compute/MetricsGrid.tsx
msgid "RAM"
msgstr "RAM"

#: src/modules/compute/VmToolbar.tsx
msgid "RDP link"
msgstr "RDP-linkki"

#: src/modules/services/ServiceView.tsx
msgid "Read more"
msgstr "Lue lisää"

#. Only read permissions
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Read-only"
msgstr "Vain luku"

#: src/modules/services/ServiceView.tsx
msgid "Readiness"
msgstr "Valmius"

#: src/modules/metal/os/MetalOsSelect.tsx
msgid "Ready"
msgstr "Valmis"

#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
msgid "Reboot"
msgstr "Käynnistä uudelleen"

#: src/modules/dashboard/RecentlyModified.tsx
msgid "Recent"
msgstr "Viimeisimmät"

#: src/modules/billing/progressLabels.tsx
msgid "Redirecting to payment gateway"
msgstr "Uudelleenohjataan maksuyhdyskäytävään"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral code"
msgstr "Suosittelukoodi"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral link"
msgstr "Suosittelulinkki"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral program"
msgstr "Suositteluohjelma"

#: src/modules/billing/account_validation/RefreshStatusButton.tsx
msgid "Refresh status"
msgstr "Päivitä tila"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Registration number"
msgstr "Y-tunnus"

#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/ReinstallModal.tsx
msgid "Reinstall"
msgstr "Asenna uudelleen"

#: src/modules/compute/ReinstallModal.tsx
msgid "Reinstalling \"{name}\" will destroy all data on the boot disk and set it to the initial clean OS state. All snapshots and backups are preserved."
msgstr "\"{name}\"-resurssin uudelleenasennus tuhoaa kaikki käynnistyslevyn tiedot ja palauttaa sen alkuperäiseen, puhtaaseen käyttöjärjestelmän tilaan. Kaikki tilannekuvat ja varmuuskopiot säilytetään."

#: src/components/sidebar/ListErrorBoundary.tsx
msgid "Reload"
msgstr "Lataa uudelleen"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Reload data"
msgstr "Lataa tiedot uudelleen"

#: src/root.tsx
msgid "Reload page"
msgstr "Lataa sivu uudelleen"

#: src/modules/billing/PaymentTopItem.tsx
msgid "Remaining credit <0/>"
msgstr "Jäljellä oleva saldo <0/>"

#: src/modules/network/firewall/FirewallView.tsx
msgid "Remove resource"
msgstr "Poista resurssi"

#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "Removing the public IPv4 address assignment from this resource will make the resource inaccessible from the public Internet. The IP address will remain reserved to your account. You can manage public IPv4 addresses from the Network menu on the left sidebar."
msgstr "Julkisen IPv4-osoitteen liitoksen poistaminen tästä resurssista tekee resurssista saavuttamattoman julkisesta internetistä. IP-osoite pysyy varattuna tilillesi. Voit hallita julkisia IPv4-osoitteita vasemman sivupalkin Verkko-valikosta."

#. placeholder {0}: item.grantee_username
#: src/modules/access/delegation/DelegationView.tsx
msgid "Removing user will revoke the rights from \"{0}\" to act as you."
msgstr "Käyttäjän poistaminen peruuttaa käyttäjältä \"{0}\" oikeuden toimia puolestasi."

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Rename"
msgstr "Nimeä uudelleen"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Report"
msgstr "Raportti"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Report {id}"
msgstr "Raportti {id}"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Reports"
msgstr "Raportit"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Requested"
msgstr "Pyydetty"

#: src/modules/metal/commitment/AddCommitmentModal.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Reservations"
msgstr "Varaukset"

#. Disk status
#: src/modules/disks/DiskList.tsx
#: src/modules/disks/DiskStatusBadge.tsx
msgid "Reserved"
msgstr "Varattu"

#: src/modules/metal/commitment/CommitmentPriceBlock.tsx
msgid "Reserved and prepaid until <0/> ({daysRemaining} days remaining). Price shown as a monthly equivalent."
msgstr "Varattu ja maksettu etukäteen päivään <0/> asti ({daysRemaining} päivää jäljellä). Hinta näytetään kuukausittaisena vastaavana hintana."

#: src/modules/user/ProfileView.tsx
msgid "Reset password"
msgstr "Vaihda salasana"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmView.tsx
msgid "Resize"
msgstr "Muuta kokoa"

#: src/modules/compute/DiskAddOrResizeModal.tsx
msgid "Resize disk"
msgstr "Muuta levyn kokoa"

#: src/modules/compute/VmResizeModal.tsx
msgid "Resizing is only possible when the virtual machine is stopped."
msgstr "Koon muuttaminen on mahdollista vain, kun virtuaalikone on pysäytetty."

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Resource name"
msgstr "Resurssin nimi"

#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Resources"
msgstr "Resurssit"

#. VM is accessible by:
#: src/modules/compute/VmView.tsx
msgid "resources in the same VPC network using private addresses of primary interfaces"
msgstr "saman VPC-verkon resursseista ensisijaisten liitäntöjen yksityisosoitteilla"

#. VM is accessible by:
#: src/modules/compute/VmView.tsx
msgid "resources in the VPCs shared by VLAN sub-interfaces using their respective private address"
msgstr "VLAN-aliliitäntöjen jakamien VPC-verkkojen resursseista niiden omilla yksityisosoitteilla"

#: src/modules/billing/omise/parseOmisePersistentData.ts
msgid "Response seems to be taking longer than expected. Wait a bit and refresh the page to see changes reflected. The result might be either successful or unsuccessful."
msgstr "Vastaus näyttää kestävän odotettua kauemmin. Odota hetki ja päivitä sivu nähdäksesi muutokset. Tulos voi olla joko onnistunut tai epäonnistunut."

#: src/modules/billing/payment/paymentUtils.ts
msgid "Response seems to be taking more time than expected. Wait a bit and refresh the page to see payment status changes reflected. If it doesn't happen in a reasonable time, please contact support."
msgstr "Vastauksen saaminen näyttää kestävän odotettua kauemmin. Odota hetki ja päivitä sivu nähdäksesi maksun tilan muutokset. Jos muutoksia ei näy kohtuullisessa ajassa, ota yhteyttä tukeen."

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/Backups.tsx
msgid "Restore"
msgstr "Palauta"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/services/Backups.tsx
msgid "Restore from backup"
msgstr "Palauta varmuuskopiosta"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restore from snapshot"
msgstr "Palauta tilannekuvasta"

#: src/modules/services/Backups.tsx
msgid "Restoring from a backup will overwrite the service's state with the selected backup's state."
msgstr "Varmuuskopiosta palauttaminen korvaa palvelun tilan valitun varmuuskopion tilalla."

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restoring this backup will overwrite the current state."
msgstr "Tämän varmuuskopion palauttaminen korvaa nykyisen tilan."

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restoring this snapshot will overwrite the current state."
msgstr "Tämän tilannekuvan palauttaminen korvaa nykyisen tilan."

#: src/modules/access/scopeLabel.tsx
msgid "Restricted"
msgstr "Rajoitettu"

#: src/modules/compute/VmView.tsx
msgid "Retention"
msgstr "Säilytysaika"

#. Button action
#: src/components/sidebar/ErrorItem.tsx
#: src/modules/notifications/toast.tsx
msgid "Retry"
msgstr "Yritä uudelleen"

#: src/styles/readyidc/theme.tsx
msgid "Revolutionize your cloud with AMD EPYC"
msgstr "Uudista pilvipalvelusi AMD EPYCillä"

#. Registre National des Entreprises (RNE) company registration document
#: src/styles/dataxion/theme.tsx
msgid "RNE document"
msgstr "RNE-asiakirja"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Rules from all attached firewalls are combined, a connection is allowed if there is at least one rule that allows it."
msgstr "Kaikkien liitettyjen palomuurien säännöt yhdistetään. Yhteys sallitaan, jos vähintään yksi sääntö sallii sen."

#: src/modules/metal/MetalCreate.tsx
msgid "Run your applications on Bare Metal Servers for full control, security, and raw performance. Provision a dedicated server optimized for your most demanding use cases."
msgstr "Suorita sovelluksesi bare metal -palvelimilla saadaksesi täyden hallinnan, turvallisuuden ja raakaa suorituskykyä. Ota käyttöön dedikoitu palvelin, joka on optimoitu vaativimpiin käyttötapauksiisi."

#. Virtual machine status
#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/monitor/MetricChart.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/services/ServicesList.tsx
msgid "Running"
msgstr "Käynnissä"

#: src/modules/storage/StorageCreate.tsx
msgid "S3-compatible object storage allows you to scale your storage resources up and down without any upfront payments. Create a new storage account, create some buckets and start storing your data in a scalable way - Pay-as-you-grow."
msgstr "S3-yhteensopiva objektitallennus mahdollistaa tallennusresurssien skaalauksen ylös ja alas ilman ennakkomaksuja. Luo uusi tallennustili, luo tallennussäiliöitä ja aloita datasi tallentaminen skaalautuvasti – maksat käytön mukaan."

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
#: src/modules/currency/CurrencyModal.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Save"
msgstr "Tallenna"

#: src/modules/billing/progressLabels.tsx
msgid "Saving payment information"
msgstr "Tallennetaan maksutietoja"

#: src/modules/billing/QrCodeDisplay.tsx
msgid "Scan the QR code to pay"
msgstr "Maksa skannaamalla QR-koodi"

#: src/modules/access/AccessCreate.tsx
#: src/modules/user/ProfileView.tsx
msgid "Scope"
msgstr "Laajuus"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Search"
msgstr "Hae"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Secret access key"
msgstr "Salainen pääsyavain"

#: src/modules/billing/forms/FileWithSourceInput.tsx
msgid "Select a file"
msgstr "Valitse tiedosto"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Select a payment method"
msgstr "Valitse maksutapa"

#: src/components/forms/WSelect.tsx
msgid "Select an option"
msgstr "Valitse vaihtoehto"

#. placeholder {0}: siteCurrencyInfo.title
#: src/modules/currency/CurrencyModal.tsx
msgid "Select your display currency to view prices in your preferred currency. Displayed amounts and exchange rates are indicative and for informational purposes only. All transactions are processed in the underlying currency ({0}), and final charges may vary based on your payment provider's rates."
msgstr "Valitse näytettävä valuutta nähdäksesi hinnat haluamassasi valuutassa. Näytetyt summat ja valuuttakurssit ovat suuntaa-antavia ja vain tiedoksi. Kaikki tapahtumat käsitellään perusvaluutassa ({0}), ja lopulliset veloitukset voivat vaihdella maksupalveluntarjoajasi kurssien mukaan."

#: src/modules/currency/CurrencyModal.tsx
msgid "Select your preferred currency"
msgstr "Valitse haluamasi valuutta"

#: src/modules/compute/WVnc.tsx
msgid "Send Ctrl+Alt+Del"
msgstr "Lähetä Ctrl+Alt+Del"

#: src/modules/login/Login.tsx
msgid "Send email"
msgstr "Lähetä sähköposti"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Server"
msgstr "Palvelin"

#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/pricing/PricingModal.tsx
msgid "Server class"
msgstr "Palvelinluokka"

#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServiceView.tsx
msgid "Service"
msgstr "Palvelu"

#: src/modules/services/ServiceCreate.tsx
msgid "Service name"
msgstr "Palvelun nimi"

#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/services/ServicesList.tsx
msgid "Services"
msgstr "Palvelut"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Set default"
msgstr "Aseta oletukseksi"

#. 'private' is a literal string
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Set object's ACL to 'private'"
msgstr "Aseta objektin ACL-arvoksi 'private'"

#. 'public-read' is a literal string
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Set object's ACL to 'public-read'"
msgstr "Aseta objektin ACL-arvoksi 'public-read'"

#. Button action
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/dashboard/UserAccess.tsx
msgid "Share access"
msgstr "Jaa käyttöoikeus"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on Facebook"
msgstr "Jaa Facebookissa"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on LinkedIn"
msgstr "Jaa LinkedInissä"

#. X is the social network
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on X"
msgstr "Jaa X:ssä"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Share temporarily"
msgstr "Jaa väliaikaisesti"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sharing duration"
msgstr "Jakamisen kesto"

#. Button action
#: src/components/SecretKey.tsx
#: src/modules/services/TextSecret.tsx
msgid "Show"
msgstr "Näytä"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Show details"
msgstr "Näytä tiedot"

#. An item is any kind of resource being managed (e.g. VM, disk, bucket, etc).
#: src/modules/dashboard/RecentlyModified.tsx
msgid "Showing {limit} latest items"
msgstr "Näytetään {limit} viimeisintä kohdetta"

#: src/modules/billing/BillingDiscountNotice.tsx
msgid "Showing list prices. Discount applied in the cost summary."
msgstr "Näytetään listahinnat. Alennus huomioidaan kustannusyhteenvedossa."

#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
msgid "Sign up"
msgstr "Rekisteröidy"

#: src/modules/login/Login.tsx
msgid "Sign up with Google"
msgstr "Rekisteröidy Googlella"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageList.tsx
msgid "Size"
msgstr "Koko"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
msgid "Size (GB)"
msgstr "Koko (GB)"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
msgid "Snapshots"
msgstr "Tilannekuvat"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Social share"
msgstr "Jaa somessa"

#: src/modules/metal/spec/SpecRadio.tsx
msgid "Sold out"
msgstr "Loppuunmyyty"

#. Label for dropdown menu that selects by what files are sorted. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort"
msgstr "Lajittele"

#: src/components/sidebar/SortMenu.tsx
msgid "Sort by"
msgstr "Lajittele"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by date"
msgstr "Lajittele päivämäärän mukaan"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by name"
msgstr "Lajittele nimen mukaan"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by size"
msgstr "Lajittele koon mukaan"

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
msgid "Source port"
msgstr "Lähdeportti"

#: src/modules/network/loadbalancer/validatePorts.ts
msgid "Source port must be unique"
msgstr "Lähdeportin on oltava yksilöllinen"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Sources"
msgstr "Lähteet"

#: src/modules/compute/AddSshKeyModal.tsx
msgid "SSH key does not match required pattern"
msgstr "SSH-avain ei vastaa vaadittua muotoa"

#: src/modules/compute/VmCreate.tsx
#: src/modules/user/ProfileView.tsx
msgid "SSH keys"
msgstr "SSH-avaimet"

#: src/modules/compute/VmCreate.tsx
msgid "SSH keys can be managed under your <0>user profile</0>."
msgstr "SSH-avaimia voi hallita <0>käyttäjäprofiilissasi</0>."

#: src/modules/compute/VmToolbar.tsx
msgid "SSH link"
msgstr "SSH-linkki"

#: src/modules/compute/VmRootUserWarning.tsx
msgid "SSH might not be available for root user due to operating system initial setup. Please use virtual console to access the system and make the SSH server config changes according to your needs."
msgstr "SSH ei välttämättä ole käytettävissä root-käyttäjälle käyttöjärjestelmän alkuasetusten vuoksi. Käytä järjestelmään pääsyyn virtuaalikonsolia ja tee SSH-palvelimen asetuksiin tarvittavat muutokset."

#. Button action
#: src/modules/compute/BootFromIsoModal.tsx
#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/support/WChatProvider.tsx
#: src/modules/user/ActAsModal.tsx
msgid "Start"
msgstr "Käynnistä"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Start date"
msgstr "Aloituspäivä"

#: src/modules/billing/account_validation/digio/StartDigioValidationButton.tsx
msgid "Start here"
msgstr "Aloita tästä"

#: src/modules/network/NetworkCreate.tsx
msgid "Start managing your networks by creating a new network resource."
msgstr "Aloita verkkojesi hallinta luomalla uusi verkkoresurssi."

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Start port"
msgstr "Alkuportti"

#: src/modules/network/firewall/validatePorts.ts
msgid "Start port must be unique"
msgstr "Alkuportin on oltava yksilöllinen"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Start something new"
msgstr "Aloita jotain uutta"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Start time"
msgstr "Aloitusaika"

#: src/modules/billing/progressLabels.tsx
msgid "Starting payment"
msgstr "Maksu käynnistyy"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "State"
msgstr "Osavaltio"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Status"
msgstr "Tila"

#: src/modules/compute/ModalHeaderBlock.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Stop"
msgstr "Pysäytä"

#. Virtual machine status
#: src/modules/compute/ModalHeaderBlock.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/services/ServicesList.tsx
msgid "Stopped"
msgstr "Pysäytetty"

#. Virtual machine status
#: src/modules/compute/statusLabels.tsx
msgid "Stopping"
msgstr "Pysäytetään"

#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/storage/StorageList.tsx
msgid "Storage"
msgstr "Tallennus"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Storage access keys"
msgstr "Tallennuksen pääsyavaimet"

#: src/modules/api/resourceTypes.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Storage account"
msgstr "Tallennustili"

#: src/modules/api/resourceTypes.tsx
msgid "Storage bucket"
msgstr "Säiliö"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "Storage bucket name"
msgstr "Säiliön nimi"

#. List of S3 storage buckets
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Storage buckets"
msgstr "Tallennussäiliöt"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Street address"
msgstr "Katuosoite"

#: src/modules/services/ConnectionDetails.tsx
msgid "String"
msgstr "Merkkijono"

#: src/modules/network/NetworkCreate.tsx
msgid "Subnet range (CIDR)"
msgstr "Aliverkon alue (CIDR)"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Subtotal"
msgstr "Välisumma"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Subtotal before discounts"
msgstr ""

#. Button label. Short of: Contact customer support
#: src/modules/main/TopNav.tsx
msgid "Support"
msgstr "Tuki"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Suspended"
msgstr "Keskeytetty"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Switch to Grid view"
msgstr "Vaihda ruudukkonäkymään"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Switch to List view"
msgstr "Vaihda luettelonäkymään"

#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "system"
msgstr "järjestelmä"

#: src/modules/compute/labels.tsx
msgid "Take a snapshot to create an instant image of your virtual machine's current state. You can later use the snapshot to restore your virtual machine state or create a new virtual machine from the snapshot with modified size parameters."
msgstr "Ota tilannekuva luodaksesi välittömän levykuvan virtuaalikoneen nykyisestä tilasta. Voit myöhemmin käyttää tilannekuvaa virtuaalikoneen tilan palauttamiseen tai luoda tilannekuvasta uuden virtuaalikoneen muutetuilla kokoparametreilla."

#: src/modules/compute/VmView.tsx
msgid "Take snapshot"
msgstr "Ota tilannekuva"

#: src/modules/dashboard/RecentlyModified.tsx
msgid "Take some action and you'll never see this cactus again."
msgstr "Tee jokin toimenpide, niin et näe tätä kaktusta enää."

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Target port"
msgstr "Kohdeportti"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Target servers"
msgstr "Kohdepalvelimet"

#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/WVnc.tsx
msgid "Terminal"
msgstr "Konsoli"

#: src/modules/login/ConsentForm.tsx
msgid "Terms of Service"
msgstr "Käyttöehdot"

#: src/modules/pricing/PricingModal.tsx
msgid "The actual cost of your resource is calculated based on the below prices and your actual hourly usage. All prices are per one unit of resource (1 vCPU or 1 GiB). Prices do not contain taxes."
msgstr "Resurssisi todellinen kustannus lasketaan alla olevien hintojen ja toteutuneen tuntikäyttösi perusteella. Kaikki hinnat ovat per resurssiyksikkö (1 vCPU tai 1 GiB). Hinnat eivät sisällä veroja."

#: src/modules/billing/forms/BillingSelect.tsx
msgid "The billing account has been closed and is no longer available."
msgstr "Laskutustili on suljettu eikä ole enää käytettävissä."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "The campaign code is activated only after a successful top up."
msgstr "Kampanjakoodi aktivoituu vasta onnistuneen saldon täydennyksen jälkeen."

#: src/modules/user/ActAsModal.tsx
msgid "The entire user interface will switch and act as you were that user. Once you are finished you can stop the session by clicking “Back to your account” button on the header bar and the user interface will switch back to your account."
msgstr "Koko käyttöliittymä vaihtuu ja toimii ikään kuin olisit kyseinen käyttäjä. Kun olet valmis, voit lopettaa istunnon napsauttamalla yläpalkissa painiketta ”Takaisin omaan tiliisi”, jolloin käyttöliittymä vaihtuu takaisin tilillesi."

#: src/modules/billing/ConversionMessage.tsx
msgid "The final exchange rate and charge amount will be determined at the moment of actual payment."
msgstr "Lopullinen vaihtokurssi ja veloitettava summa määräytyvät varsinaisen maksun hetkellä."

#: src/modules/billing/promotionNotices.tsx
msgid "The first top up will unlock your complimentary free credit of <0><1/></0>."
msgstr "Ensimmäinen saldon täydennys avaa sinulle maksuttoman hyvityksen: <0><1/></0>."

#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "The format is MM/YY"
msgstr "Muoto on KK/VV"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "The link expires on:"
msgstr "Linkki vanhenee:"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "The name can only contain lowercase alphanumeric characters and dashes, it must start with a lowercase letter or number, the allowed length is 3–63."
msgstr "Nimi voi sisältää vain pieniä kirjaimia, numeroita ja tavuviivoja; sen on alettava pienellä kirjaimella tai numerolla, ja sallittu pituus on 3–63."

#: src/modules/compute/ChangePasswordModal.tsx
msgid "The password can be changed for any existing user account."
msgstr "Salasana voidaan vaihtaa mille tahansa olemassa olevalle käyttäjätilille."

#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "The phone/mobile number to contact if any issue arises"
msgstr "Puhelin-/matkapuhelinnumero, johon otetaan yhteyttä ongelmatilanteissa"

#: src/components/forms/MonthlyCostField.tsx
msgid "The price is approximate, the cost of your resource will be calculated based on your actual hourly usage."
msgstr "Hinta on arvio, resurssisi kustannus lasketaan todellisen tuntikohtaisen käytön perusteella."

#: src/modules/compute/PasswordFields.tsx
msgid "The re-typed password, to ensure that it has been entered correctly."
msgstr "Uudelleen kirjoitettu salasana sen varmistamiseksi, että se on syötetty oikein."

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "The selected billing account does not have enough credit to purchase this reservation."
msgstr "Valitulla laskutustilillä ei ole riittävästi saldoa tämän varauksen ostamiseen."

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "The selected billing account is limited and can not create reservations."
msgstr "Valittu laskutustili on rajoitettu eikä sillä voi luoda varauksia."

#: src/modules/network/NetworkCreate.tsx
msgid "The subnet must fall within one the following IP blocks:"
msgstr "Aliverkon on sisällyttävä johonkin seuraavista IP-lohkoista:"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "The user account for which password will be set."
msgstr "Käyttäjätili, jolle salasana asetetaan."

#: src/modules/login/Login.tsx
msgid "There was an error verifying your email address."
msgstr "Sähköpostiosoitteen vahvistamisessa tapahtui virhe."

#: src/components/sidebar/ErrorItem.tsx
msgid "There was an error while creating your resource."
msgstr "Resurssiasi luotaessa tapahtui virhe."

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "These credentials are only for the initial login. It is recommended to change these immediately."
msgstr "Nämä kirjautumistiedot ovat vain ensimmäistä kirjautumista varten. Suosittelemme vaihtamaan ne välittömästi."

#. This resource was not found
#: src/modules/error/ErrorFallback.tsx
msgid "This {resourceTypeName} is gone"
msgstr "Tämä {resourceTypeName} on poissa"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "This bare metal server is still being set up."
msgstr "Tätä bare metal -palvelinta valmistellaan edelleen."

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "This billing account has limited capabilities when creating resources."
msgstr "Tällä laskutustilillä on rajoitetut mahdollisuudet resurssien luomisessa."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "This billing account is limited"
msgstr "Tämä laskutustili on rajoitettu"

#: src/modules/compute/VmCreate.tsx
msgid "This distribution adds a <0/> cost per hour for licensing (<1/> per month)."
msgstr "Tämä jakelu lisää lisensoinnista kustannuksen <0/> tunnissa (<1/> kuukaudessa)."

#: src/components/forms/requiredMessage.tsx
msgid "This field is required"
msgstr "Tämä kenttä on pakollinen"

#: src/modules/storage/account/CreateKeyModal.tsx
msgid "This key has access to all buckets under this storage account. To restrict access to specific buckets, create a separate storage account."
msgstr "Tällä avaimella on pääsy kaikkiin tämän tallennustilin tallennussäiliöihin. Jos haluat rajoittaa pääsyn tiettyihin tallennussäiliöihin, luo erillinen tallennustili."

#. This page was not found
#: src/modules/error/ErrorFallback.tsx
msgid "This page is gone"
msgstr "Tämä sivu on poissa"

#: src/modules/services/Access.tsx
#: src/modules/services/Networking.tsx
msgid "This service is accessible only by resources in the same VPC network using these private addresses."
msgstr "Tämä palvelu on käytettävissä vain samassa VPC-verkossa olevista resursseista näitä yksityisiä osoitteita käyttäen."

#: src/modules/compute/VmView.tsx
msgid "This virtual machine is accessible by:"
msgstr "Tähän virtuaalikoneeseen pääsee seuraavasti:"

#: src/modules/network/firewall/FirewallDeleteModal.tsx
msgid "This will delete the firewall and its associated rules, and they will no longer apply to any assigned resources."
msgstr "Tämä poistaa palomuurin ja siihen liittyvät säännöt, eikä niitä enää sovelleta mihinkään liitettyihin resursseihin."

#: src/modules/compute/VmToolbar.tsx
msgid "This will forcefully shut down your resource \"{name}\". For stopped resources you will only be charged for the storage."
msgstr "Tämä pysäyttää resurssin \"{name}\" pakottamalla. Pysäytetyistä resursseista veloitetaan vain tallennustilasta."

#: src/modules/services/ServiceView.tsx
msgid "This will hibernate cluster \"{display_name}\"."
msgstr "Tämä asettaa klusterin \"{display_name}\" horrostilaan."

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/storage/StorageCreate.tsx
msgid "This will only be used within the system so it's easy for you to recognize the account if you have several."
msgstr "Tätä käytetään vain järjestelmässä, jotta tunnistat tilin helposti, jos sinulla on useita."

#: src/modules/compute/VmToolbar.tsx
msgid "This will reboot your resource \"{name}\"."
msgstr "Tämä käynnistää resurssin \"{name}\" uudelleen."

#: src/modules/services/IpWhitelist.tsx
msgid "This will remove the address or range from the allowlist.<0/>Note that an empty allowlist will permit connections from any address."
msgstr "Tämä poistaa osoitteen tai alueen sallittujen IP-osoitteiden luettelosta.<0/>Huomaa, että tyhjä sallittujen IP-osoitteiden luettelo sallii yhteydet mistä tahansa osoitteesta."

#: src/modules/services/ServiceView.tsx
msgid "This will shut down your resource \"{display_name}\". If graceful shutdown does not finish in 120 seconds, then a forceful stop will be carried out. For stopped resources you will only be charged for the storage."
msgstr "Tämä sammuttaa resurssin \"{display_name}\". Jos hallittu sammutus ei valmistu 120 sekunnissa, suoritetaan pakotettu pysäytys. Pysäytetyistä resursseista veloitetaan vain tallennustilasta."

#: src/modules/compute/VmToolbar.tsx
msgid "This will shut down your resource \"{name}\". If graceful shutdown does not finish in 120 seconds, then a forceful stop will be carried out. For stopped resources you will only be charged for the storage."
msgstr "Tämä sammuttaa resurssin \"{name}\". Jos hallittu sammutus ei valmistu 120 sekunnissa, suoritetaan pakotettu pysäytys. Pysäytetyistä resursseista veloitetaan vain tallennustilasta."

#: src/modules/network/loadbalancer/LoadBalancerDeleteModal.tsx
msgid "This will stop forwarding traffic to the targets and remove the load balancer."
msgstr "Tämä lopettaa liikenteen välittämisen kohteisiin ja poistaa kuormantasaajan."

#. Amount below which a low balance notification will be sent
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Threshold"
msgstr "Raja-arvo"

#. This page was not found
#: src/modules/error/ErrorFallback.tsx
msgid "Time to move on. Here are some ideas where to go next:"
msgstr "On aika jatkaa eteenpäin. Tässä muutama idea, minne mennä seuraavaksi:"

#: src/modules/error/ErrorFallback.tsx
msgid "Time to move on. This item is deleted or you do not have access."
msgstr "On aika jatkaa eteenpäin. Tämä kohde on poistettu tai sinulla ei ole käyttöoikeutta."

#: src/modules/billing/razorpay/RazorpayPaymentForm.tsx
msgid "Timed out waiting for a response from Razorpay"
msgstr "Razorpayn vastausta odotettaessa tapahtui aikakatkaisu"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Timezone"
msgstr "Aikavyöhyke"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "To activate a billing account, please add a credit card as a payment method or contact support to enable invoice payments."
msgstr "Aktivoidaksesi laskutustilin lisää luottokortti maksutavaksi tai ota yhteyttä tukeen ottaaksesi laskumaksut käyttöön."

#: src/modules/services/IpWhitelist.tsx
msgid "To restrict connections to the service you have to add at least one inbound IP to the allowlist (All other public and private connections will be denied). You can specify a single IPv4 address or a block of addresses using CIDR notation (e.g. 1.1.1.0/24)"
msgstr "Rajoittaaksesi yhteyksiä palveluun sinun on lisättävä sallittujen IP-osoitteiden luetteloon vähintään yksi saapuva IP-osoite (kaikki muut julkiset ja yksityiset yhteydet estetään). Voit määrittää yksittäisen IPv4-osoitteen tai osoitelohkon CIDR-merkinnällä (esim. 1.1.1.0/24)."

#: src/modules/billing/BillingAccountNotices.tsx
#: src/modules/dashboard/WelcomeModal.tsx
msgid "To start using the platform you need to first setup billing account. You are welcome to click around to familiarize yourself with the system and come back to billing account creation at any time you are ready to start building your first resources."
msgstr "Aloittaaksesi alustan käytön sinun on ensin luotava laskutustili. Voit vapaasti tutustua järjestelmään klikkailemalla ympäriinsä ja palata laskutustilin luomiseen milloin tahansa, kun olet valmis luomaan ensimmäiset resurssisi."

#: src/modules/login/ConsentForm.tsx
msgid "To use our services, you need to agree to the Terms of Service."
msgstr "Jotta voit käyttää palveluitamme, sinun on hyväksyttävä käyttöehdot."

#: src/modules/access/token/TokenView.tsx
msgid "Token"
msgstr "Token"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Top up"
msgstr "Täydennä saldoa"

#. How much to top up | POS: Noun
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Top up amount"
msgstr "Täydennyssumma"

#: src/modules/billing/promotionNotices.tsx
msgid "Top up at least <0><1/></0> to obtain <2><3/></2> of referral code bonus."
msgstr "Täydennä saldoa vähintään <0><1/></0>, jotta saat suosittelukoodibonuksena <2><3/></2>."

#: src/modules/billing/ActionButtons.tsx
msgid "Top up now"
msgstr "Täydennä saldoa nyt"

#. Top up your billing account
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Top up your account"
msgstr "Täydennä tilisi saldoa"

#. Invoices for billing account top-ups
#: src/components/themeTrans.tsx
msgid "Top-up invoices"
msgstr "Saldontäydennyslaskut"

#: src/styles/dataxion/theme.tsx
msgid "Top-up orders"
msgstr "Saldon täydennystilaukset"

#. Total amount of the invoice
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Total"
msgstr "Yhteensä"

#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Total charge"
msgstr "Kokonaisveloitus"

#. Short of: Total excluding
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Total excl. {vatSymbol}"
msgstr "Yhteensä ilman {vatSymbol}"

#: src/components/themeTrans.tsx
msgid "Total of all unpaid invoices. Including {vatSymbol}."
msgstr "Kaikkien maksamattomien laskujen yhteissumma. Sisältää {vatSymbol}."

#: src/styles/dataxion/theme.tsx
msgid "Total of all unpaid orders. Including VAT."
msgstr "Kaikkien maksamattomien tilausten yhteissumma. Sisältää ALV:n."

#: src/modules/billing/CurrencyPaymentFees.tsx
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Transaction fee"
msgstr "Tapahtumamaksu"

#: src/modules/access/AccessCreate.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageCreate.tsx
msgid "Type"
msgstr "Tyyppi"

#: src/modules/compute/labels.tsx
msgid "UEFI variables (NVRAM) will not persist across reboots."
msgstr "UEFI-muuttujat (NVRAM) eivät säily uudelleenkäynnistysten välillä."

#: src/modules/access/AccessList.tsx
msgid "UI"
msgstr "Käyttöliittymä"

#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/ipAddress/UnAssignButton.tsx
msgid "Unassign"
msgstr "Poista liitos"

#. State of IP address
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/UnassignedItem.tsx
msgid "Unassigned"
msgstr "Liittämätön"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Unit"
msgstr "Yksikkö"

#. Label for an unknown item in a select control
#: src/components/EnumBadge.tsx
#: src/modules/billing/BillingAccountLink.tsx
#: src/modules/network/NetworkList.tsx
msgid "Unknown"
msgstr "Tuntematon"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Unknown Auth0 error"
msgstr "Tuntematon Auth0-virhe"

#: src/modules/access/scopeLabel.tsx
msgid "Unknown billing account"
msgstr "Tuntematon laskutustili"

#: src/modules/billing/payment/paymentUtils.ts
msgid "Unknown payment error{codeSuffix}"
msgstr "Tuntematon maksuvirhe{codeSuffix}"

#: src/modules/disks/AttachedToSelect.tsx
#: src/modules/network/AssignToSelect.tsx
msgid "Unknown resource"
msgstr "Tuntematon resurssi"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Unlink target"
msgstr "Poista kohteen linkitys"

#: src/modules/billing/BillingList.tsx
#: src/modules/billing/ReportStatus.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Unpaid"
msgstr "Maksamatta"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Unpaid amount"
msgstr "Maksamaton summa"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Unverified"
msgstr "Vahvistamaton"

#: src/modules/compute/UpdateSshKeyModal.tsx
msgid "Update"
msgstr "Päivitä"

#: src/modules/compute/UpdateSshKeyModal.tsx
msgid "Update SSH key"
msgstr "Päivitä SSH-avain"

#. Button action to upload a file. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Upload"
msgstr "Lähetä"

#: src/styles/dataxion/theme.tsx
msgid "Upload a copy of only the RNE document for verification"
msgstr "Lähetä varmennusta varten kopio ainoastaan RNE-asiakirjasta"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Uploading files"
msgstr "Lähetetään tiedostoja"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Uploads are still in progress. If you leave this page, progress will no longer be shown and uploads may be interrupted. Leave anyway?"
msgstr "Tiedostoja lähetetään edelleen. Jos poistut tältä sivulta, edistymistä ei enää näytetä ja lähetykset voivat keskeytyä. Poistutaanko silti?"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Usage"
msgstr "Käyttö"

#: src/modules/compute/VmCreate.tsx
msgid "Use the ISO boot option after the virtual machine has been created to install an operating system yourself."
msgstr "Käytä ISO-käynnistysvaihtoehtoa virtuaalikoneen luomisen jälkeen, jotta voit asentaa käyttöjärjestelmän itse."

#: src/modules/dashboard/UserAccess.tsx
msgid "User access"
msgstr "Käyttöoikeudet"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/UserAccess.tsx
msgid "User must accept access invitation from their profile view"
msgstr "Käyttäjän on hyväksyttävä käyttöoikeuskutsu profiilinäkymästä"

#. Link to regular user interface
#: src/modules/user/UserMenu.tsx
msgid "User view"
msgstr "Käyttäjänäkymä"

#: src/modules/access/delegation/AddImpersonationForm.tsx
msgid "User's email"
msgstr "Käyttäjän sähköpostiosoite"

#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
msgid "Username"
msgstr "Käyttäjätunnus"

#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/ProfileView.tsx
msgid "Users I can access"
msgstr "Käyttäjät, joihin minulla on pääsy"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/ProfileView.tsx
msgid "Users who can access my account"
msgstr "Käyttäjät, joilla on pääsy tililleni"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "UUID"
msgstr "UUID"

#: src/modules/billing/payment_forms/labels.tsx
msgid "Valid thru"
msgstr "Voimassa asti"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Validation pending"
msgstr "Vahvistus odottaa"

#: src/modules/compute/ParamsTextField.tsx
msgid "Value does not match required pattern"
msgstr "Arvo ei vastaa vaadittua muotoa"

#: src/components/VatText.tsx
msgid "VAT"
msgstr "ALV"

#: src/components/VatText.tsx
msgid "VAT number"
msgstr "ALV-numero"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
#: src/modules/compute/MachineSizeInfo.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "vCPU"
msgstr "vCPU"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Verified"
msgstr "Vahvistettu"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Verified payment method is missing"
msgstr "Vahvistettu maksutapa puuttuu"

#: src/modules/billing/progressLabels.tsx
msgid "Verifying payment method"
msgstr "Vahvistetaan maksutapaa"

#: src/modules/compute/os/OsVersionSelect.tsx
#: src/modules/metal/os/MetalOsSelect.tsx
#: src/modules/services/os/OsVersionSelect.tsx
msgid "Version"
msgstr "Versio"

#. Button action
#: src/components/ResourceLink.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/notifications/toast.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "View"
msgstr "Näytä"

#: src/components/table/WTable.tsx
msgid "View all records"
msgstr "Näytä kaikki tietueet"

#: src/modules/compute/VmView.tsx
msgid "View config commands"
msgstr "Näytä määrityskomennot"

#: src/modules/billing/BillingAccountNotices.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "View details"
msgstr "Näytä tiedot"

#: src/components/table/WTable.tsx
msgid "View last {limit} records"
msgstr "Näytä viimeiset {limit} tietuetta"

#: src/modules/user/InvitationNotice.tsx
msgid "View more"
msgstr "Näytä lisää"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Virtual host style URL"
msgstr "Virtuaalipalvelinmuotoinen URL-osoite"

#: src/modules/api/resourceTypes.tsx
msgid "Virtual machine"
msgstr "Virtuaalikone"

#: src/modules/compute/SubInterfaceModal.tsx
msgid "VLAN"
msgstr "VLAN"

#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmView.tsx
msgid "VLAN ID"
msgstr "VLAN-tunnus"

#: src/modules/services/Networking.tsx
msgid "VPC IP range"
msgstr "VPC:n IP-alue"

#: src/modules/compute/VmView.tsx
msgid "VPC name"
msgstr "VPC:n nimi"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/VpcRow.tsx
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/services/Networking.tsx
#: src/modules/services/ServiceCreate.tsx
msgid "VPC network"
msgstr "VPC-verkko"

#: src/modules/network/NetworkCreate.tsx
msgid "VPC network is available at no additional cost."
msgstr "VPC-verkko on saatavilla ilman lisäkustannuksia."

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Wait for verification or add card"
msgstr "Odota vahvistusta tai lisää kortti"

#: src/modules/billing/progressLabels.tsx
msgid "Waiting for payment confirmation"
msgstr "Odotetaan maksun vahvistusta"

#: src/modules/billing/popup/popup.ts
msgid "Waiting for popup to return from redirect timed out"
msgstr "Ponnahdusikkunan uudelleenohjauksesta palaamisen odotus aikakatkaistiin"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Waking up"
msgstr "Herätetään"

#: src/modules/access/AdminUserWarning.tsx
#: src/modules/compute/VmCreate.tsx
msgid "Warning"
msgstr "Varoitus"

#: src/modules/compute/DiskAddOrResizeModal.tsx
msgid "Warning: It is recommended to stop the virtual machine before resizing the boot disk."
msgstr "Varoitus: Suosittelemme virtuaalikoneen pysäyttämistä ennen käynnistyslevyn koon muuttamista."

#: src/modules/billing/choose_method/invoiceMethodLogic.tsx
msgid "We recommend adding a credit card while your request is being processed to activate services right away."
msgstr "Suosittelemme lisäämään luottokortin, kun pyyntöäsi käsitellään, jotta palvelut voidaan aktivoida heti."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "We recommend automated top up as it minimizes the risk of running out of funds and thus affecting your server resources."
msgstr "Suosittelemme automaattista saldon täydennystä, sillä se minimoi riskin saldon loppumisesta ja siten palvelinresurssien toimintaan kohdistuvista vaikutuksista."

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "We've assembled some links to get you started. Develop, test code, and deploy your applications in no time, from prototyping to large-scale development."
msgstr "Olemme koonneet linkkejä, joiden avulla pääset alkuun. Kehitä, testaa koodia ja ota sovelluksesi käyttöön hetkessä prototyypistä laajamittaiseen kehitykseen."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "We've reached the capacity of our file browser. In order to maintain the stability of our user interface, we've terminated the loading of your bucket contents. Please utilize external tools at your disposal to manage the content within your bucket"
msgstr "Tiedostoselaimen kapasiteetti on saavutettu. Käyttöliittymän vakauden varmistamiseksi olemme lopettaneet tallennussäiliön sisällön lataamisen. Käytä tallennussäiliön sisällön hallintaan ulkoisia työkaluja."

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Welcome"
msgstr "Tervetuloa"

#: src/modules/dashboard/WelcomeModal.tsx
msgid "Welcome!<0/>We're glad you're here."
msgstr "Tervetuloa!<0/>Mukava, että olet täällä."

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "What would you like to do?"
msgstr "Mitä haluat tehdä?"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "When balance goes below"
msgstr "Kun saldo alittaa"

#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "When reserved but not assigned to a resource IPv4 address will be charged for <0/> / month."
msgstr "Kun IPv4-osoite on varattu mutta sitä ei ole liitetty resurssiin, siitä veloitetaan <0/> / kuukausi."

#: src/modules/network/CreateAndAssignIpField.tsx
msgid "When selected, a public floating IPv4 address will be created and assigned automatically to your resource. If you do not want to have public access to your resource you can unselect the option here or remove the IP address later."
msgstr "Kun tämä on valittuna, luodaan julkinen kelluva IPv4-osoite ja se liitetään automaattisesti resurssiisi. Jos et halua julkista pääsyä resurssiisi, voit poistaa valinnan tästä tai poistaa IP-osoitteen myöhemmin."

#: src/modules/compute/VmView.tsx
msgid "When you enable the backup service, an automatic disk-level backup will be created from the boot disk (excluding additional disks). A backup will be created once a week and will be listed here. You can later use the backup images to restore your virtual machine or create a new virtual machine with modified size parameters from the backup."
msgstr "Kun otat varmuuskopiointipalvelun käyttöön, käynnistyslevystä luodaan automaattinen levytason varmuuskopio (lisälevyjä ei sisällytetä). Varmuuskopio luodaan kerran viikossa ja se näkyy täällä. Voit myöhemmin käyttää varmuuskopiolevykuvia virtuaalikoneen palauttamiseen tai luoda varmuuskopiosta uuden virtuaalikoneen muutetuilla kokoparametreilla."

#: src/components/loading/Loading.tsx
msgid "While the job is in progress you can:"
msgstr "Työn ollessa käynnissä voit:"

#: src/modules/api/resourceTypes.tsx
msgid "With a firewall you can control incoming and outgoing network traffic based on predetermined security rules."
msgstr "Palomuurin avulla voit hallita sisään- ja ulosmenevää verkkoliikennettä ennalta määritettyjen tietoturvasääntöjen perusteella."

#: src/modules/billing/firstAccountNotices.store.tsx
msgid "With first billing account you will be able to unlock your complimentary free credit of <0><1/></0>."
msgstr "Ensimmäisen laskutustilin avulla voit ottaa käyttöön maksuttoman hyvityksesi <0><1/></0>."

#. placeholder {0}: currency.title
#: src/modules/billing/ConversionMessage.tsx
msgid "With the selected payment method, you will be charged in {0}."
msgstr "Valitulla maksutavalla sinua veloitetaan valuutassa {0}."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Without an active billing account you can not create any resources, create one to get started."
msgstr "Ilman aktiivista laskutustiliä et voi luoda resursseja. Luo laskutustili aloittaaksesi."

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Without an active billing account, resources can not be created."
msgstr "Ilman aktiivista laskutustiliä resursseja ei voi luoda."

#. Time period unit
#: src/modules/metal/offer/period.tsx
msgid "year"
msgstr "vuosi"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Yearly"
msgstr "Vuosittainen"

#: src/modules/disks/disk/DiskView.tsx
msgid "Yes"
msgstr "Kyllä"

#: src/modules/user/ActAsModal.tsx
msgid "You are about to access user \"{name}\""
msgstr "Olet avaamassa käyttäjän \"{name}\""

#: src/modules/access/AdminUserWarning.tsx
msgid "You are an administrator and are about to delegate your administrative privileges to another user. Please ensure this action is intentional."
msgstr "Olet ylläpitäjä ja olet delegoimassa ylläpitäjän oikeuksiasi toiselle käyttäjälle. Varmista, että tämä toiminto on tarkoituksellinen."

#: src/modules/user/ProfileView.tsx
msgid "You can activate multi-factor authentication for improved security. This works only for the username-password login method. For social login methods (Google etc.), it is usually possible to activate MFA on the third party side."
msgstr "Voit ottaa käyttöön monivaiheisen tunnistautumisen parantaaksesi turvallisuutta. Tämä toimii vain käyttäjätunnus–salasana-kirjautumisessa. Sosiaalisissa kirjautumistavoissa (Google jne.) MFA on yleensä mahdollista ottaa käyttöön kolmannen osapuolen palvelussa."

#: src/modules/compute/BootFromIsoModal.tsx
msgid "You can boot your virtual machine from a special image for system recovery or to install a fresh operating system. When this mode is activated, a chosen image will be attached as a boot medium. You can then use the Terminal to access your machine. This boot mode is enabled only for the current launch. Next time this virtual machine is started it will follow the normal boot routine."
msgstr "Voit käynnistää virtuaalikoneesi erityisestä levykuvasta järjestelmän palautusta varten tai uuden käyttöjärjestelmän asentamiseksi. Kun tämä tila on käytössä, valittu levykuva liitetään käynnistysmediaksi. Voit sitten käyttää konsolia koneeseen pääsyyn. Tämä käynnistystila on käytössä vain tämän käynnistyksen ajan. Seuraavalla kerralla, kun tämä virtuaalikone käynnistetään, se noudattaa normaalia käynnistysrutiinia."

#: src/modules/billing/PaymentReturn.tsx
msgid "You can close this page."
msgstr "Voit sulkea tämän sivun."

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "You can create multiple billing accounts, each linked to specific payment methods. This approach allows you to effectively separate and monitor expenses across different teams, departments, or projects."
msgstr "Voit luoda useita laskutustilejä, joista kukin on linkitetty tiettyihin maksutapoihin. Näin voit tehokkaasti erotella ja seurata kuluja eri tiimien, osastojen tai projektien välillä."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You can do this from here and continue it later by clicking the link in the email we send you."
msgstr "Voit tehdä tämän täällä ja jatkaa myöhemmin klikkaamalla lähettämämme sähköpostin linkkiä."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "You can earn and give free credits by sharing your unique referral code."
msgstr "Voit ansaita ja jakaa maksutonta saldoa jakamalla ainutlaatuisen suosittelukoodisi."

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "You cannot add another reservation because a future reservation already exists."
msgstr "Et voi lisätä uutta varausta, koska tuleva varaus on jo olemassa."

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "You commit to the full price for the selected period as soon as you confirm the reservation."
msgstr "Sitoudut maksamaan valitun jakson koko hinnan heti, kun vahvistat varauksen."

#. placeholder {0}: ipAddress.address
#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "You have a floating IP <0>{0}</0> assigned to this resource."
msgstr "Tähän resurssiin on liitetty kelluva IP-osoite <0>{0}</0>."

#: src/modules/billing/firstAccountNotices.store.tsx
msgid "You have an active campaign code (<0>{referralCode}</0>) pending to get additional bonus!"
msgstr "Sinulla on aktiivinen kampanjakoodi (<0>{referralCode}</0>), joka odottaa lisäbonuksen myöntämistä!"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You have billing account validation in progress."
msgstr "Laskutustilin validointi on käynnissä."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You have completed billing account validation process. Please wait for the final decision."
msgstr "Olet suorittanut laskutustilin validointiprosessin. Odota lopullista päätöstä."

#: src/modules/notifications/NotificationMenu.tsx
msgid "You have no notifications."
msgstr "Sinulla ei ole ilmoituksia."

#: src/modules/billing/QrCodeDisplay.tsx
msgid "You may close this dialog after you have made a payment."
msgstr "Voit sulkea tämän ikkunan, kun olet suorittanut maksun."

#: src/modules/billing/payment/PaymentModal.tsx
msgid "You may close this dialog window for now."
msgstr "Voit sulkea tämän valintaikkunan toistaiseksi."

#: src/modules/storage/bucket/BucketView.tsx
msgid "You need to have at least one access key for browsing files in this bucket."
msgstr "Tarvitset vähintään yhden pääsyavaimen tämän tallennussäiliön tiedostojen selaamiseen."

#: src/modules/billing/account_validation/GeneralBaValidationBlock.tsx
msgid "You will be able to set up payment methods and use cloud services once the validation is approved."
msgstr "Voit määrittää maksutavat ja käyttää pilvipalveluita, kun validointi on hyväksytty."

#: src/modules/billing/NoValidBillingAccountNotice.tsx
msgid "You will be able to set up payment methods and use cloud services once the validation is complete."
msgstr "Voit määrittää maksutavat ja käyttää pilvipalveluita, kun varmistus on valmis."

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "You will not be charged until it is ready."
msgstr "Sinua ei veloiteta ennen kuin se on valmis."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Your account has been suspended"
msgstr "Tilisi on keskeytetty"

#: src/modules/billing/ConversionMessage.tsx
msgid "Your actual charge will be <0/>, with exchange rate of <1/>."
msgstr "Todellinen veloitus on <0/>, vaihtokurssilla <1/>."

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Your billing account has been suspended. See billing account details for more information and <0>contact support</0> to resolve the issue."
msgstr "Laskutustilisi on keskeytetty. Katso lisätietoja laskutustilin tiedoista ja <0>ota yhteyttä tukeen</0> ongelman ratkaisemiseksi."

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Your billing account has been topped up"
msgstr "Laskutustilisi saldoa on täydennetty"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Your billing account must have positive balance to get activated."
msgstr "Laskutustilin saldon on oltava positiivinen, jotta se voidaan aktivoida."

#: src/modules/login/Login.tsx
msgid "Your email address has been successfully verified. You can now log in."
msgstr "Sähköpostiosoitteesi on vahvistettu onnistuneesti. Voit nyt kirjautua sisään."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Your email address has changed since you started validation. Please start over."
msgstr "Sähköpostiosoitteesi on muuttunut validoinnin aloittamisen jälkeen. Aloita alusta."

#: src/modules/billing/BillingDiscountNotice.tsx
msgid "Your selected billing account has {discount}% discount"
msgstr "Valitulla laskutustililläsi on {discount}% alennus"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Your storage bucket contains a substantial number of files, and we've temporarily halted the loading process. Simply click the \"Load More\" button to continue loading the next batch of files."
msgstr "Tallennussäiliössäsi on huomattava määrä tiedostoja, ja olemme keskeyttäneet lataamisen väliaikaisesti. Jatka seuraavan tiedostoerän lataamista napsauttamalla \"Lataa lisää\" -painiketta."

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Zip/postal code"
msgstr "Postinumero"
